"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggerConf = exports.Logger = exports.initCustomLogger = void 0;
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'ec-sf' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 10 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'ec-sf' });
    }
    ;
    /**
    * @typedef {Object} clientCallingSetupForGettingExperimentsParams
    * @property {string} appName - null
    * @property {string} direction - to petri / from petri
    * @property {boolean} isMerchant - null
    * @property {GUID} msid - msid
    * @property {GUID} bi_token - null
    * @property {string} result - result from petri server
    * @property {GUID} storeId - store_id
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Client calling “setup” for getting experiments. Evid: 888.
     * Event description: Client calling “setup” for getting experiments on this visitor.
    
     * appName - Type: string.
     *
     * direction - Type: string. Desc: to petri / from petri
     *
     * isMerchant - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * bi_token - Type: guid.
     *
     * result - Type: string. Desc: result from petri server
     *
     * storeId - Type: guid. Desc: store_id
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {clientCallingSetupForGettingExperimentsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clientCallingSetupForGettingExperiments = function (params) {
        return this.bi.log(__assign({ evid: 888 }, params));
    };
    /**
    * @typedef {Object} currencyConverterChooseSiteCurrencyDisplayParams
    * @property {string} appName - currencyconverter-settings
    * @property {string} editorMode - mobile / desktop
    * @property {GUID} instance_id - instance_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} newValue - chosen display currency
    * @property {string} siteCurrency - original site currency
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: currency converter - choose site currency display. Evid: 534.
     * Event description: when a buyer chooses the site currency display in the currency converter dropdown.
    
     * appName - Type: string. Desc: currencyconverter-settings
     *
     * editorMode - Type: string. Desc: mobile / desktop
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * newValue - Type: string. Desc: chosen display currency
     *
     * siteCurrency - Type: string. Desc: original site currency
     *
     * storeId - Type: guid. Desc: store_id
     * @param {currencyConverterChooseSiteCurrencyDisplayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.currencyConverterChooseSiteCurrencyDisplay = function (params) {
        return this.bi.log(__assign({ evid: 534 }, params));
    };
    /**
    * @typedef {Object} couponAppliedSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} couponCode - null
    * @property {boolean} isMember - is_member
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click 'Apply' Coupon  SF. Evid: 112.
     * Event description: after entering promo code click on Apply. since june 2019 can be sent also from OA StoreFront.
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * couponCode - Type: string.
     *
     * isMember - Type: bool. Desc: is_member
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {couponAppliedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.couponAppliedSf = function (params) {
        return this.bi.log(__assign({ evid: 112 }, params));
    };
    /**
    * @typedef {Object} productGalleryResizeSfParams
    * @property {string} appName - null
    * @property {GUID} categoryId - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    * @property {number} newGalleryWidth - null
    **/
    /**
     * Name: product Gallery Resize SF. Evid: 15.
    
    
     * appName - Type: string.
     *
     * categoryId - Type: guid.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     *
     * newGalleryWidth - Type: numeric.
     * @param {productGalleryResizeSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.productGalleryResizeSf = function (params) {
        return this.bi.log(__assign({ evid: 15 }, params));
    };
    /**
    * @typedef {Object} placeOrderSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {string} couponCode - coupon_code
    * @property {boolean} customFieldMandatory - true - if custom field was mandatory on checkout
    * @property {string} flowType - fast flow / quick flow
    * @property {string} giftCardCode - gift_card_code
    * @property {boolean} hasCustomField - true - if order was placed with filled custom field
    * @property {boolean} is_member - is_memebr
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant
    * @property {GUID} bi_token - null
    * @property {number} numOfLineItems - number of uniq products
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {string} paymentMethod - paymentMethod
    * @property {GUID} siteMemberId - member id
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Click Place order SF. Evid: 168.
     * Event description: click on place order (client event). since june 2019 also from OneApp (leads to cashier screen to choose payment method and pay).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * couponCode - Type: string. Desc: coupon_code
     *
     * customFieldMandatory - Type: bool. Desc: true - if custom field was mandatory on checkout
     *
     * flowType - Type: string. Desc: fast flow / quick flow
     *
     * giftCardCode - Type: string. Desc: gift_card_code
     *
     * hasCustomField - Type: bool. Desc: true - if order was placed with filled custom field
     *
     * is_member - Type: bool. Desc: is_memebr
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant
     *
     * bi_token - Type: guid.
     *
     * numOfLineItems - Type: numeric. Desc: number of uniq products
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * paymentMethod - Type: string. Desc: paymentMethod
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {placeOrderSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.placeOrderSf = function (params) {
        return this.bi.log(__assign({ evid: 168 }, params));
    };
    /**
    * @typedef {Object} clickOnCustomizeButtonInTheSettingsMenuParams
    * @property {string} appName - app_name
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - store_id
    * @property {string} targetTab - the target tab this buton reffer to
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: Click on Customize button in the settings menu. Evid: 35.
     * Event description: click on customize button in the main tab on the new settings menu
    (For members components).
    
     * appName - Type: string. Desc: app_name
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid. Desc: store_id
     *
     * targetTab - Type: string. Desc: the target tab this buton reffer to
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {clickOnCustomizeButtonInTheSettingsMenuParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnCustomizeButtonInTheSettingsMenu = function (params) {
        return this.bi.log(__assign({ evid: 35 }, params));
    };
    /**
    * @typedef {Object} clickOnUpgradeButtonInProPlanModalParams
    * @property {string} appName - null
    * @property {string} component_id - CurrencyConverter, AvalaraTax
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding / StoresBO
    * @property {string} package_name - The type of the premium package that is connected to the site (if free then null)
    * @property {GUID} storeId - store_id
    * @property {string} type - button / tooltip / banner
    **/
    /**
     * Name: High RPU -> Click in upgrade modal. Evid: 847.
     * Event description: When the user clicks on the upgrade button in pro plan modal (high RPU upgrade modal).
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: CurrencyConverter, AvalaraTax
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding / StoresBO
     *
     * package_name - Type: string. Desc: The type of the premium package that is connected to the site (if free then null)
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: button / tooltip / banner
     * @param {clickOnUpgradeButtonInProPlanModalParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnUpgradeButtonInProPlanModal = function (params) {
        return this.bi.log(__assign({ evid: 847 }, params));
    };
    /**
    * @typedef {Object} currencyConverterClickAddCurrencySfeParams
    * @property {string} appName - currencyconverter-settings
    * @property {GUID} instance_id - instance_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: currency converter - click ‘Add Currency’ SFE. Evid: 530.
     * Event description: click ‘Add Currency’ in currency converter settings (under 'Currencies' panel) to open modal..
    
     * appName - Type: string. Desc: currencyconverter-settings
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {currencyConverterClickAddCurrencySfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.currencyConverterClickAddCurrencySfe = function (params) {
        return this.bi.log(__assign({ evid: 530 }, params));
    };
    /**
    * @typedef {Object} clickedOnProductQuickViewSfParams
    * @property {string} appName - null
    * @property {boolean} hasOptions - null
    * @property {boolean} hasRibbon - null
    * @property {number} index - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} productId - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Clicked on product quick view SF. Evid: 12.
    
    
     * appName - Type: string.
     *
     * hasOptions - Type: bool.
     *
     * hasRibbon - Type: bool.
     *
     * index - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * productId - Type: string.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {clickedOnProductQuickViewSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickedOnProductQuickViewSf = function (params) {
        return this.bi.log(__assign({ evid: 12 }, params));
    };
    /**
    * @typedef {Object} productAddedToWishlistSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product have options
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - null
    * @property {string} origin - product-page / gallery-page / quick-view / product-widget
    * @property {GUID} owner_id - id of site's owner. since june 2019
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: Product added to wishlist SF. Evid: 267.
     * Event description: when a product was successfully added to wishlist after the buyer clicks on button.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product have options
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: product-page / gallery-page / quick-view / product-widget
     *
     * owner_id - Type: guid. Desc: id of site's owner. since june 2019
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {productAddedToWishlistSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.productAddedToWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 267 }, params));
    };
    /**
    * @typedef {Object} changeHoverTypeSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider gallery, product page, product widget...
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - null
    * @property {string} type - chosen hover type
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change hover type SFE. Evid: 828.
     * Event description: merchant changes hover behavior in widget settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider gallery, product page, product widget...
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: chosen hover type
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeHoverTypeSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeHoverTypeSfe = function (params) {
        return this.bi.log(__assign({ evid: 828 }, params));
    };
    /**
    * @typedef {Object} chooseAPageToDisplayThisCollectionOnClickedParams
    * @property {string} appName - null
    * @property {string} button_name - Add collection/ cancel
    * @property {string} categoryId - collection id
    * @property {string} name - collection_name
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {string} pageName - page_name if available
    * @property {string} pageType - new/existing
    * @property {GUID} storeId - null
    **/
    /**
     * Name: Choose a Page to display this collection on clicked. Evid: 471.
     * Event description: in the editor, when adding a collection , coming from SM CTA - add collection to page..
    
     * appName - Type: string.
     *
     * button_name - Type: string. Desc: Add collection/ cancel
     *
     * categoryId - Type: string. Desc: collection id
     *
     * name - Type: string. Desc: collection_name
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * pageName - Type: string. Desc: page_name if available
     *
     * pageType - Type: string. Desc: new/existing
     *
     * storeId - Type: guid.
     * @param {chooseAPageToDisplayThisCollectionOnClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.chooseAPageToDisplayThisCollectionOnClicked = function (params) {
        return this.bi.log(__assign({ evid: 471 }, params));
    };
    /**
    * @typedef {Object} checkoutPageSpecificStageExpandedSfParams
    * @property {string} additionalRequiredField - only for 'placeOrderFastFlow' stage: required additional field that we didnt get info fron PayPal) for "Place Order" button to be clickable='state'/'zip code' / 'state and zip code' / 'none'
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {string} flowType - 'quick flow' / 'full flow'
    * @property {boolean} giftCardChecked - payment stage only -  true if gift card checkbox is checked on load
    * @property {boolean} hasGiftCard - payment stage only - true  if visitor sees the Gift Card Checkbox
    * @property {boolean} isFirstTimeUsage - True If the user sees this stage for the first time, false if it's from edit click
    * @property {boolean} isGiftCardApplied - payment stage only  - true if giftcard is already applied on load
    * @property {boolean} isCartPaidOnlyWithGiftCard - payment stage only  - if true cashier component is hidden (due to gift card fully cover the order (with coupon or without)
    * @property {boolean} is_member - true is the visitor signed in as a member, false otherwise
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant false for member
    * @property {GUID} bi_token - msid
    * @property {number} num_of_shipping - number of shipping choices presented to the visitor at the first time
    * @property {string} origin - 'OA StoreFront' (for OneApp)
    * @property {GUID} owner_id - uuid of site owner
    * @property {boolean} savedAddress - true if the member has saved address
    * @property {string} shippingMethodType - shipping /store pickup / none
    * @property {GUID} siteMemberId - member
    * @property {string} stage - the edited stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: checkout page -> specific stage expanded SF. Evid: 37.
     * Event description: when a new stage is expanded and another collapse.
    When all data is visible. since june 2019 is sent also from OneApp.
    
     * additionalRequiredField - Type: string. Desc: only for 'placeOrderFastFlow' stage: required additional field that we didnt get info fron PayPal) for "Place Order" button to be clickable='state'/'zip code' / 'state and zip code' / 'none'
     *
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * flowType - Type: string. Desc: 'quick flow' / 'full flow'
     *
     * giftCardChecked - Type: bool. Desc: payment stage only -  true if gift card checkbox is checked on load
     *
     * hasGiftCard - Type: bool. Desc: payment stage only - true  if visitor sees the Gift Card Checkbox
     *
     * isFirstTimeUsage - Type: bool. Desc: True If the user sees this stage for the first time, false if it's from edit click
     *
     * isGiftCardApplied - Type: bool. Desc: payment stage only  - true if giftcard is already applied on load
     *
     * isCartPaidOnlyWithGiftCard - Type: bool. Desc: payment stage only  - if true cashier component is hidden (due to gift card fully cover the order (with coupon or without)
     *
     * is_member - Type: bool. Desc: true is the visitor signed in as a member, false otherwise
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant false for member
     *
     * bi_token - Type: guid. Desc: msid
     *
     * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor at the first time
     *
     * origin - Type: string. Desc: 'OA StoreFront' (for OneApp)
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * savedAddress - Type: bool. Desc: true if the member has saved address
     *
     * shippingMethodType - Type: string. Desc: shipping /store pickup / none
     *
     * siteMemberId - Type: guid. Desc: member
     *
     * stage - Type: string. Desc: the edited stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {checkoutPageSpecificStageExpandedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.checkoutPageSpecificStageExpandedSf = function (params) {
        return this.bi.log(__assign({ evid: 37 }, params));
    };
    /**
    * @typedef {Object} oaSfClickOnProductSocialShareParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - msid
    * @property {string} productId - product guid
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: OA SF - Click on Product social share. Evid: 226.
     * Event description: when member click on social share for product in Store Front OneApp. Till 09.03.20 was sent from ec-sm, 10-22.03.20 was invalid (started to be sent from ec-sf but no changes in Catalog) , since 23.03 copied to ec-sf.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid. Desc: msid
     *
     * productId - Type: string. Desc: product guid
     *
     * storeId - Type: guid. Desc: store_id
     * @param {oaSfClickOnProductSocialShareParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oaSfClickOnProductSocialShare = function (params) {
        return this.bi.log(__assign({ evid: 226 }, params));
    };
    /**
    * @typedef {Object} viewCartPageSfParams
    * @property {string} appName - app_name
    * @property {string} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {boolean} isFullWidth - is the full width setting in the cart on / off
    * @property {boolean} is_member - true is the visitor signed in as a member, false otherwise
    * @property {boolean} isMembersInstalled - true if members app installed on site, false otherwise
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected (and displaying in cart)
    * @property {boolean} is_with_offline_payment - does the store has an offline payment connected
    * @property {GUID} bi_token - msid
    * @property {number} lineItemsCount - number of line items in cart
    * @property {number} num_of_paymet_providers - How many payment providers does the store has connected
    * @property {number} num_of_shipping - number of shipping choices presented to the visitor at the first time
    * @property {string} origin - add to cart / mini cart / cart widget / checkout / 'eWallet redirect - cancel'
    * @property {GUID} owner_id - owner_id
    * @property {string} paymet_providers - array of payment providers connected to the store
    * @property {GUID} siteMemberId - member guid
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    * @property {string} viewMode - editor / site / preview
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: view cart page SF. Evid: 124.
     * Event description: view cart page. since june 2019 also for OneApp Store front.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: string. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * isFullWidth - Type: bool. Desc: is the full width setting in the cart on / off
     *
     * is_member - Type: bool. Desc: true is the visitor signed in as a member, false otherwise
     *
     * isMembersInstalled - Type: bool. Desc: true if members app installed on site, false otherwise
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected (and displaying in cart)
     *
     * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
     *
     * bi_token - Type: guid. Desc: msid
     *
     * lineItemsCount - Type: numeric. Desc: number of line items in cart
     *
     * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
     *
     * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor at the first time
     *
     * origin - Type: string. Desc: add to cart / mini cart / cart widget / checkout / 'eWallet redirect - cancel'
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * paymet_providers - Type: string. Desc: array of payment providers connected to the store
     *
     * siteMemberId - Type: guid. Desc: member guid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     *
     * viewMode - Type: string. Desc: editor / site / preview
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {viewCartPageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 124 }, params));
    };
    /**
    * @typedef {Object} removedProductFromCartSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {number} itemsCount - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true  - for merchant false for member
    * @property {GUID} bi_token - null
    * @property {string} origin - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} productId - null
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Removed product from cart SF. Evid: 115.
     * Event description: Removed product from cart SF. since june 2019 also for OneApp StoreFront (member view).
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * itemsCount - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true  - for merchant false for member
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * productId - Type: string.
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {removedProductFromCartSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.removedProductFromCartSf = function (params) {
        return this.bi.log(__assign({ evid: 115 }, params));
    };
    /**
    * @typedef {Object} clickRemoveFromWishlistSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product have options
    * @property {boolean} hasRibbon - does the product have ribbon
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - null
    * @property {string} origin - product-page / wishlist-gallery
    * @property {GUID} owner_id - id of site's owner. since june 2019
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: Click remove from wishlist SF. Evid: 261.
     * Event description: buyer clicks on to remove product feom wishlist.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product have options
     *
     * hasRibbon - Type: bool. Desc: does the product have ribbon
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: product-page / wishlist-gallery
     *
     * owner_id - Type: guid. Desc: id of site's owner. since june 2019
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {clickRemoveFromWishlistSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickRemoveFromWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 261 }, params));
    };
    /**
    * @typedef {Object} socialButtonsParams
    * @property {string} appName - null
    * @property {string} socialButton - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} productId - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Social buttons. Evid: 62.
     * Event description: when a buyer clicks on the social buttons in the product page.
    
     * appName - Type: string.
     *
     * socialButton - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * productId - Type: string.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {socialButtonsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.socialButtons = function (params) {
        return this.bi.log(__assign({ evid: 62 }, params));
    };
    /**
    * @typedef {Object} errorInCheckoutSfParams
    * @property {string} appName - stores
    * @property {GUID} cartId - na
    * @property {string} errorMessage - detailed error message
    * @property {string} field - cardNumber/expirationDate/postalCode/cvv/ county_code
    * @property {boolean} isMember - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {string} message - for example Expiration date is not valid / shipping is not avilable
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {GUID} siteMemberId - site_member_id
    * @property {string} stage - what stage in the chechout funnel the error is
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - na
    **/
    /**
     * Name: Error in checkout SF. Evid: 24.
     * Event description: errors in checkoutfunnel. since june 2019 also sent from OneApp (origin = 'OA StoreFront').
    
     * appName - Type: string. Desc: stores
     *
     * cartId - Type: guid. Desc: na
     *
     * errorMessage - Type: string. Desc: detailed error message
     *
     * field - Type: string. Desc: cardNumber/expirationDate/postalCode/cvv/ county_code
     *
     * isMember - Type: bool.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * message - Type: string. Desc: for example Expiration date is not valid / shipping is not avilable
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * siteMemberId - Type: guid. Desc: site_member_id
     *
     * stage - Type: string. Desc: what stage in the chechout funnel the error is
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: na
     * @param {errorInCheckoutSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.errorInCheckoutSf = function (params) {
        return this.bi.log(__assign({ evid: 24 }, params));
    };
    /**
    * @typedef {Object} clickOnRelatedProductOaParams
    * @property {string} appName - null
    * @property {string} id - product_id of related product
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - msid
    * @property {string} productId - product_id of main product
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Click on related product OA SF. Evid: 229.
     * Event description: user clicked on related product in main product screen OA.
    
     * appName - Type: string.
     *
     * id - Type: string. Desc: product_id of related product
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid. Desc: msid
     *
     * productId - Type: string. Desc: product_id of main product
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {clickOnRelatedProductOaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnRelatedProductOa = function (params) {
        return this.bi.log(__assign({ evid: 229 }, params));
    };
    /**
    * @typedef {Object} errorWhenApplyingACouponSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} couponCode - null
    * @property {string} errorCode - null
    * @property {boolean} isMember - is_member
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Error when applying a coupon SF. Evid: 117.
    
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * couponCode - Type: string.
     *
     * errorCode - Type: string.
     *
     * isMember - Type: bool. Desc: is_member
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {errorWhenApplyingACouponSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.errorWhenApplyingACouponSf = function (params) {
        return this.bi.log(__assign({ evid: 117 }, params));
    };
    /**
    * @typedef {Object} clickInWarningScreenOaStoreFrontParams
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - true
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    * @property {string} type - payments / view_store
    * @property {string} value - close / not now / contact
    **/
    /**
     * Name: Click in warning/info screen OA StoreFront. Evid: 270.
     * Event description: click in unable to accept payment screen (not now / contact)/ 2nd level invitation (when user is redirected from 2nd level invitation to a hidden or deleted product) screen.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: true
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: payments / view_store
     *
     * value - Type: string. Desc: close / not now / contact
     * @param {clickInWarningScreenOaStoreFrontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickInWarningScreenOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 270 }, params));
    };
    /**
    * @typedef {Object} clickOnAddToCartSfParams
    * @property {string} appName - null
    * @property {string} socialButton - null
    * @property {string} buttonType - buy now / add to cart / subscribe now
    * @property {number} quantity - null
    * @property {boolean} hasOptions - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isNavigateCart - true if the button redirect to cart (mobile or without cart icon), false otherwise
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - null
    * @property {string} navigationClick - mini-cart / cart  / none / checkout
    * @property {string} options - a json containing the options selected for the product
    * @property {string} origin - null
    * @property {GUID} owner_id - id of site's owner. since june 2019
    * @property {string} productId - null
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {string} viewMode - editor / site / preview
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click on add to cart. Evid: 63.
     * Event description: buyer clicks on add to cart. Also since june 2019 can be sent from OneApp store front (member view) with origin ='OA StoreFront'.
    
     * appName - Type: string.
     *
     * socialButton - Type: string.
     *
     * buttonType - Type: string. Desc: buy now / add to cart / subscribe now
     *
     * quantity - Type: numeric.
     *
     * hasOptions - Type: bool.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isNavigateCart - Type: bool. Desc: true if the button redirect to cart (mobile or without cart icon), false otherwise
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid.
     *
     * navigationClick - Type: string. Desc: mini-cart / cart  / none / checkout
     *
     * options - Type: string. Desc: a json containing the options selected for the product
     *
     * origin - Type: string.
     *
     * owner_id - Type: guid. Desc: id of site's owner. since june 2019
     *
     * productId - Type: string.
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * viewMode - Type: string. Desc: editor / site / preview
     *
     * visitor_id - Type: guid.
     * @param {clickOnAddToCartSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnAddToCartSf = function (params) {
        return this.bi.log(__assign({ evid: 63 }, params));
    };
    /**
    * @typedef {Object} clickToAddWishlistSfeParams
    * @property {string} appName - null
    * @property {string} component_id - product
    * @property {boolean} hasMembers - Does the site have members area installed when adding wishlist (different buttons)
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click to add Wishlist SFE. Evid: 841.
     * Event description: when a user clicks to add wishlist in product page settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: product
     *
     * hasMembers - Type: bool. Desc: Does the site have members area installed when adding wishlist (different buttons)
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickToAddWishlistSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToAddWishlistSfe = function (params) {
        return this.bi.log(__assign({ evid: 841 }, params));
    };
    /**
    * @typedef {Object} membersClickChangeInCheckoutStagesSfParams
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {GUID} siteMemberId - member id
    * @property {string} stage - stage in checkout (delivery, payment...)
    * @property {GUID} storeId - store_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: members -> click 'change' in checkout stages SF. Evid: 46.
     * Event description: click to 'change' autofill info in the checkout process.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * stage - Type: string. Desc: stage in checkout (delivery, payment...)
     *
     * storeId - Type: guid. Desc: store_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {membersClickChangeInCheckoutStagesSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.membersClickChangeInCheckoutStagesSf = function (params) {
        return this.bi.log(__assign({ evid: 46 }, params));
    };
    /**
    * @typedef {Object} changeGalleryLayoutSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {string} editorMode - mobile/desktop
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} parameter - columns / rows / margins
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    * @property {string} value - selected value
    **/
    /**
     * Name: change gallery layout SFE. Evid: 816.
     * Event description: change gallery layout.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * editorMode - Type: string. Desc: mobile/desktop
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * parameter - Type: string. Desc: columns / rows / margins
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     *
     * value - Type: string. Desc: selected value
     * @param {changeGalleryLayoutSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeGalleryLayoutSfe = function (params) {
        return this.bi.log(__assign({ evid: 816 }, params));
    };
    /**
    * @typedef {Object} showShippingPopupSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {string} mode - mode
    * @property {GUID} bi_token - null
    * @property {string} origin - where the modal pops up (cart / product page...)
    * @property {GUID} storeId - null
    * @property {string} type - merchant pop-up / buyer pop-up
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Show merchant shipping popup SF. Evid: 173.
     * Event description: Show shipping popup - no shipping rule for destination.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * mode - Type: string. Desc: mode
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: where the modal pops up (cart / product page...)
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: merchant pop-up / buyer pop-up
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {showShippingPopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.showShippingPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 173 }, params));
    };
    /**
    * @typedef {Object} exposureEventForTestsParams
    * @property {string} appName - null
    * @property {boolean} is_eligible - true if the feature eligible, false otherwise
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isMobileFriendly - true if mobile friendly, false otherwise
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    * @property {string} testName - test name
    * @property {string} type - type of exposure point
    * @property {GUID} uuid - uuid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Exposure event for store-front tests. Evid: 45.
     * Event description: generic event fired on an exposure moment for tests. is_eligible data is: gallery -> true if filters enable in gallery;  ExpressCheckout - true if checkout is in viewer.
    
     * appName - Type: string.
     *
     * is_eligible - Type: bool. Desc: true if the feature eligible, false otherwise
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isMobileFriendly - Type: bool. Desc: true if mobile friendly, false otherwise
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * testName - Type: string. Desc: test name
     *
     * type - Type: string. Desc: type of exposure point
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {exposureEventForTestsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exposureEventForTests = function (params) {
        return this.bi.log(__assign({ evid: 45 }, params));
    };
    /**
    * @typedef {Object} updatedCartItemQuantitySfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant false for member
    * @property {GUID} bi_token - null
    * @property {string} origin - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} productId - null
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Updated cart item quantity SF. Evid: 116.
    
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant false for member
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * productId - Type: string.
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {updatedCartItemQuantitySfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.updatedCartItemQuantitySf = function (params) {
        return this.bi.log(__assign({ evid: 116 }, params));
    };
    /**
    * @typedef {Object} clickInOrderHistoryPageSfParams
    * @property {string} appName - app_name
    * @property {string} click_type - go_shopping / track_order / download / view_invoice
    * @property {string} contact_id - contact_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} orderId - order id, in case we have it (in track order, view invoice)
    * @property {string} origin - order_history_page / order_details_page
    * @property {string} productId - only for click on "Track item" in order details page
    * @property {GUID} site_member_id - member id
    * @property {GUID} storeId - instance id
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: click in order_history page  SF. Evid: 129.
     * Event description: UoU clicks that are coming from the order_history page.
    
     * appName - Type: string. Desc: app_name
     *
     * click_type - Type: string. Desc: go_shopping / track_order / download / view_invoice
     *
     * contact_id - Type: string. Desc: contact_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * orderId - Type: string. Desc: order id, in case we have it (in track order, view invoice)
     *
     * origin - Type: string. Desc: order_history_page / order_details_page
     *
     * productId - Type: string. Desc: only for click on "Track item" in order details page
     *
     * site_member_id - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: instance id
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {clickInOrderHistoryPageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickInOrderHistoryPageSf = function (params) {
        return this.bi.log(__assign({ evid: 129 }, params));
    };
    /**
    * @typedef {Object} deleteNoteToSellerSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Delete note to seller SF. Evid: 123.
     * Event description: buyer clicks on 'delete note to seller' in cart page.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {deleteNoteToSellerSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.deleteNoteToSellerSf = function (params) {
        return this.bi.log(__assign({ evid: 123 }, params));
    };
    /**
    * @typedef {Object} clickOnMyOrdersInThankYouPageOaStoreFrontParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - true for merchant
    * @property {GUID} bi_token - msid
    * @property {string} orderId - order_id
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Click on "My Orders" in Thank you page  OA StoreFront. Evid: 187.
     * Event description: in One App Sore Front )member view)  Thank you page buyer clicked My Orders (leads to open My Orders screen).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: true for merchant
     *
     * bi_token - Type: guid. Desc: msid
     *
     * orderId - Type: string. Desc: order_id
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {clickOnMyOrdersInThankYouPageOaStoreFrontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnMyOrdersInThankYouPageOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 187 }, params));
    };
    /**
    * @typedef {Object} currencyConverterClickAddCurrenciesListSfeParams
    * @property {string} appName - currencyconverter-settings
    * @property {GUID} instance_id - instance_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: currency converter - click 'Add' currencies list SFE. Evid: 532.
     * Event description: click  'General Info' in currency converter settings (under 'Currencies' panel) in the stores currency tool tip..
    
     * appName - Type: string. Desc: currencyconverter-settings
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {currencyConverterClickAddCurrenciesListSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.currencyConverterClickAddCurrenciesListSfe = function (params) {
        return this.bi.log(__assign({ evid: 532 }, params));
    };
    /**
    * @typedef {Object} clickToReOrderProductsInCollectionSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {string} targetPage - product list / product / dashboard / ....
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: click to open store manager SFE. Evid: 814.
     * Event description: clicking 're-order products in collection' (store manager is opened in collection page).
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * targetPage - Type: string. Desc: product list / product / dashboard / ....
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {clickToReOrderProductsInCollectionSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToReOrderProductsInCollectionSfe = function (params) {
        return this.bi.log(__assign({ evid: 814 }, params));
    };
    /**
    * @typedef {Object} galleryClickFilterParams
    * @property {string} appName - app
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Gallery - Click  Filter (Mobile). Evid: 140.
     * Event description: When a visitor clicks "Filter" in mobile only!.
    
     * appName - Type: string. Desc: app
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {galleryClickFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.galleryClickFilter = function (params) {
        return this.bi.log(__assign({ evid: 140 }, params));
    };
    /**
    * @typedef {Object} resetAppSettingsSfeParams
    * @property {string} appName - null
    * @property {string} component_id - component_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: reset app settings SFE. Evid: 819.
     * Event description: click on 'reset settings' in app settings panel.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: component_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {resetAppSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.resetAppSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 819 }, params));
    };
    /**
    * @typedef {Object} changeElementSettingsSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {string} element - product image, name&price&sku, product options&quantity, button, info sections, social media
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} new_value - on/off, crop/fit...
    * @property {string} origin - editor
    * @property {string} parameter - facebook,tweeter, image scaling, navigation position
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change element settings SFE. Evid: 831.
     * Event description: change element settings in SF component settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * element - Type: string. Desc: product image, name&price&sku, product options&quantity, button, info sections, social media
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * new_value - Type: string. Desc: on/off, crop/fit...
     *
     * origin - Type: string. Desc: editor
     *
     * parameter - Type: string. Desc: facebook,tweeter, image scaling, navigation position
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeElementSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeElementSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 831 }, params));
    };
    /**
    * @typedef {Object} changeSortingParameterSfeParams
    * @property {string} action - checked / unchecked
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider gallery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {string} type - sort option
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change sorting parameter SFE. Evid: 836.
     * Event description: change sorting (display title or sorting options) in the 'Sorting & Filters' tab.
    
     * action - Type: string. Desc: checked / unchecked
     *
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider gallery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: sort option
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeSortingParameterSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeSortingParameterSfe = function (params) {
        return this.bi.log(__assign({ evid: 836 }, params));
    };
    /**
    * @typedef {Object} clickOnApplyPromotionalCodeSfParams
    * @property {string} appName - null
    * @property {string} cartId - null
    * @property {boolean} isMember - is_member
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click to add Coupon  SF. Evid: 111.
     * Event description: user clicks on "add code"/"insert promo code" (first step of applying coupon) . since june 2019 also sent from OA StoreFront (member view).
    
     * appName - Type: string.
     *
     * cartId - Type: string.
     *
     * isMember - Type: bool. Desc: is_member
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {clickOnApplyPromotionalCodeSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnApplyPromotionalCodeSf = function (params) {
        return this.bi.log(__assign({ evid: 111 }, params));
    };
    /**
    * @typedef {Object} clickContinueEWalletModalSfParams
    * @property {string} appName - app name (e.g. wixstores-client-cart)
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - Numbers of items in cart
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {number} num_of_paymet_providers - How many payment providers does the store has connected
    * @property {number} num_of_shipping - number of shipping choices presented to the visitor at the first time
    * @property {string} origin - origin
    * @property {string} paymet_providers - array of payment providers connected to the store
    * @property {string} productsList - json containing all product guids for products in the cart
    * @property {GUID} storeId - store_id
    * @property {string} type - add / edit
    **/
    /**
     * Name: Click Continue e-wallet Modal SF. Evid: 225.
     * Event description: When a visitor clicks on ‘Continue’ in e-wallet Modal (after the click the visitor is supposed to view the checkout)..
    
     * appName - Type: string. Desc: app name (e.g. wixstores-client-cart)
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: Numbers of items in cart
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
     *
     * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor at the first time
     *
     * origin - Type: string. Desc: origin
     *
     * paymet_providers - Type: string. Desc: array of payment providers connected to the store
     *
     * productsList - Type: string. Desc: json containing all product guids for products in the cart
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: add / edit
     * @param {clickContinueEWalletModalSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickContinueEWalletModalSf = function (params) {
        return this.bi.log(__assign({ evid: 225 }, params));
    };
    /**
    * @typedef {Object} clickToChangeGalleryFiltersSfParams
    * @property {string} appName - app
    * @property {string} filterType - relevant filter type (color, collection, etc...)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click to change gallery filter SF. Evid: 147.
     * Event description: When a visitor changes one of the gallery filters.
    
     * appName - Type: string. Desc: app
     *
     * filterType - Type: string. Desc: relevant filter type (color, collection, etc...)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickToChangeGalleryFiltersSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToChangeGalleryFiltersSf = function (params) {
        return this.bi.log(__assign({ evid: 147 }, params));
    };
    /**
    * @typedef {Object} cartClickOnContinueShoppingSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: cart - click on continue shopping SF. Evid: 120.
     * Event description: cart - click on continue shopping.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {cartClickOnContinueShoppingSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cartClickOnContinueShoppingSf = function (params) {
        return this.bi.log(__assign({ evid: 120 }, params));
    };
    /**
    * @typedef {Object} changeFilterOptionsParameterSfeParams
    * @property {string} action - checked / unchecked
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider gallery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {string} type - filter option
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change filter options parameter SFE. Evid: 838.
     * Event description: change filters (display title/options/show).
    
     * action - Type: string. Desc: checked / unchecked
     *
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider gallery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: filter option
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeFilterOptionsParameterSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeFilterOptionsParameterSfe = function (params) {
        return this.bi.log(__assign({ evid: 838 }, params));
    };
    /**
    * @typedef {Object} currencyConverterClickDeleteCurrencySfeParams
    * @property {string} appName - currencyconverter-settings
    * @property {GUID} instance_id - instance_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: currency converter - click delete currency SFE. Evid: 533.
     * Event description: click  'General Info' in currency converter settings (under 'Currencies' panel) in the stores currency tool tip..
    
     * appName - Type: string. Desc: currencyconverter-settings
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {currencyConverterClickDeleteCurrencySfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.currencyConverterClickDeleteCurrencySfe = function (params) {
        return this.bi.log(__assign({ evid: 533 }, params));
    };
    /**
    * @typedef {Object} removeCustomFilterSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider gallery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {string} text - custom filter name
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: Remove custom filter SFE. Evid: 840.
     * Event description: add custom filter- right now it is for collections filter only.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider gallery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * text - Type: string. Desc: custom filter name
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {removeCustomFilterSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.removeCustomFilterSfe = function (params) {
        return this.bi.log(__assign({ evid: 840 }, params));
    };
    /**
    * @typedef {Object} changeStyleColorSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {string} editorMode - mobile / desktop
    * @property {string} element - product image, name&price&sku, product options&quantity, button, info sections, social media , withorders/whitoutorders
    * @property {string} value - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} parameter - style/color parameter
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change style & color SFE. Evid: 812.
     * Event description: upon changing a store style or color.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * editorMode - Type: string. Desc: mobile / desktop
     *
     * element - Type: string. Desc: product image, name&price&sku, product options&quantity, button, info sections, social media , withorders/whitoutorders
     *
     * value - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * parameter - Type: string. Desc: style/color parameter
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeStyleColorSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeStyleColorSfe = function (params) {
        return this.bi.log(__assign({ evid: 812 }, params));
    };
    /**
    * @typedef {Object} migrationClickOnCtaInStepParams
    * @property {string} appName - null
    * @property {string} button_type - migrate / ok / next....
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} step - step - welcome / site selector / loading / migrating / success / error...
    * @property {GUID} storeId - null
    **/
    /**
     * Name: migration - click on CTA in step. Evid: 301.
     * Event description: click on call to action in migration step in iframe in help center.
    
     * appName - Type: string.
     *
     * button_type - Type: string. Desc: migrate / ok / next....
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * step - Type: string. Desc: step - welcome / site selector / loading / migrating / success / error...
     *
     * storeId - Type: guid.
     * @param {migrationClickOnCtaInStepParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationClickOnCtaInStep = function (params) {
        return this.bi.log(__assign({ evid: 301 }, params));
    };
    /**
    * @typedef {Object} clickOnSettingsTopBarDesignTabParams
    * @property {string} appName - app_name
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - store_id
    * @property {string} tab - with orders / without orders
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: Click on settings Top Bar (design Tab). Evid: 34.
     * Event description: click on the top bar in the settings menu under design tab
    (For members components).
    
     * appName - Type: string. Desc: app_name
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid. Desc: store_id
     *
     * tab - Type: string. Desc: with orders / without orders
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {clickOnSettingsTopBarDesignTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnSettingsTopBarDesignTab = function (params) {
        return this.bi.log(__assign({ evid: 34 }, params));
    };
    /**
    * @typedef {Object} thankYouPageDownloadFileClickedSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} orderId - orderId
    * @property {GUID} storeId - null
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: Thank you page download file clicked SF. Evid: 175.
     * Event description: buyer clicked on download file  in Thank you page.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * orderId - Type: string. Desc: orderId
     *
     * storeId - Type: guid.
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {thankYouPageDownloadFileClickedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thankYouPageDownloadFileClickedSf = function (params) {
        return this.bi.log(__assign({ evid: 175 }, params));
    };
    /**
    * @typedef {Object} viewStorePageInEditorParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / preview
    * @property {string} pageId - page name - thank you page / product page...
    * @property {GUID} storeId - null
    **/
    /**
     * Name: view store page in editor. Evid: 18.
     * Event description: view store page in editor / preview.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / preview
     *
     * pageId - Type: string. Desc: page name - thank you page / product page...
     *
     * storeId - Type: guid.
     * @param {viewStorePageInEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewStorePageInEditor = function (params) {
        return this.bi.log(__assign({ evid: 18 }, params));
    };
    /**
    * @typedef {Object} changeMiniCartBehaviorSfeParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} parameter - parameter
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    * @property {string} value - behavior type
    **/
    /**
     * Name: change mini cart behavior SFE. Evid: 822.
     * Event description: select a behavior for click on mini cart in mini cart settings.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * parameter - Type: string. Desc: parameter
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     *
     * value - Type: string. Desc: behavior type
     * @param {changeMiniCartBehaviorSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeMiniCartBehaviorSfe = function (params) {
        return this.bi.log(__assign({ evid: 822 }, params));
    };
    /**
    * @typedef {Object} viewOrderHistoryPageSfParams
    * @property {string} appName - appName
    * @property {string} contact_id - contact id
    * @property {number} itemsCount - number of orders in the page (for without orders it will be 0)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - origin
    * @property {GUID} site_member_id - member id
    * @property {GUID} storeId - instance id
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: view order_history page SF. Evid: 127.
     * Event description: view order history page (when it is with orders or without).
    
     * appName - Type: string. Desc: appName
     *
     * contact_id - Type: string. Desc: contact id
     *
     * itemsCount - Type: numeric. Desc: number of orders in the page (for without orders it will be 0)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * site_member_id - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: instance id
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {viewOrderHistoryPageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewOrderHistoryPageSf = function (params) {
        return this.bi.log(__assign({ evid: 127 }, params));
    };
    /**
    * @typedef {Object} viewCheckoutInLiveSitePopupSfParams
    * @property {string} appName - app_name
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {string} origin - where the modal pops up (cart / product page...)
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: View checkout in live site popup SF. Evid: 273.
     * Event description: Modal opens when the user tries to view checkout in preview mode..
    
     * appName - Type: string. Desc: app_name
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: where the modal pops up (cart / product page...)
     *
     * storeId - Type: guid. Desc: store_id
     * @param {viewCheckoutInLiveSitePopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewCheckoutInLiveSitePopupSf = function (params) {
        return this.bi.log(__assign({ evid: 273 }, params));
    };
    /**
    * @typedef {Object} clickManageProductInCartOaStoreFrontParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - cart_type
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - true for owner and false for member
    * @property {GUID} bi_token - msid
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click Manage Product in cart OA StoreFront. Evid: 185.
     * Event description: wneh buyer in StoreFront (member view) clicks on Product name in cart (leads to open Manage Product popup).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: cart_type
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: true for owner and false for member
     *
     * bi_token - Type: guid. Desc: msid
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickManageProductInCartOaStoreFrontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickManageProductInCartOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 185 }, params));
    };
    /**
    * @typedef {Object} clickNoThanksOnMerchantUpgradePopupSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click no thanks on merchant upgrade popup SF. Evid: 166.
    
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {clickNoThanksOnMerchantUpgradePopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickNoThanksOnMerchantUpgradePopupSf = function (params) {
        return this.bi.log(__assign({ evid: 166 }, params));
    };
    /**
    * @typedef {Object} clickToOpenProductsListToChangeProductInWidgetSfeParams
    * @property {string} appName - app
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - store
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: click to open products list to change product in widget SFE. Evid: 837.
     * Event description: merchant click to open the product list in order to change the connected product to a product widget.
    
     * appName - Type: string. Desc: app
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid. Desc: store
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {clickToOpenProductsListToChangeProductInWidgetSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToOpenProductsListToChangeProductInWidgetSfe = function (params) {
        return this.bi.log(__assign({ evid: 837 }, params));
    };
    /**
    * @typedef {Object} clickToRemoveWishlistSfeParams
    * @property {string} appName - null
    * @property {string} component_id - product page
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click to remove Wishlist SFE. Evid: 842.
     * Event description: when a user clicks to remove wishlist in product page settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: product page
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickToRemoveWishlistSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToRemoveWishlistSfe = function (params) {
        return this.bi.log(__assign({ evid: 842 }, params));
    };
    /**
    * @typedef {Object} showMerchantPaymentPopupSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {string} mode - null
    * @property {GUID} bi_token - null
    * @property {string} origin - where the modal pops up (cart / product page...)
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Show merchant payment popup SF. Evid: 164.
    
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * mode - Type: string.
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: where the modal pops up (cart / product page...)
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {showMerchantPaymentPopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.showMerchantPaymentPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 164 }, params));
    };
    /**
    * @typedef {Object} pageLoadingTimeSfParams
    * @property {number} angularFinished_ts - angular finished time stamp
    * @property {string} appName - null
    * @property {string} appVersion - app version
    * @property {number} configPhase_ts - config phase time stamp
    * @property {number} domComplete_ts - dom complete time stamp
    * @property {number} domLoading_ts - dom loading time stamp
    * @property {boolean} isMerchant - isMerchant status
    * @property {number} latency_ts - latency time stamp
    * @property {GUID} bi_token - null
    * @property {number} preRequest_ts - pre request time stamp
    * @property {number} runPhase_ts - run_phase time stamp
    * @property {number} serverResponse_ts - server response time stamp
    * @property {number} startTime - start time for iframe loading
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: page loading time SF. Evid: 861.
     * Event description: this event holds loading time stamp for each step in wixstores iframe loading in live site.
    
     * angularFinished_ts - Type: numeric. Desc: angular finished time stamp
     *
     * appName - Type: string.
     *
     * appVersion - Type: string. Desc: app version
     *
     * configPhase_ts - Type: numeric. Desc: config phase time stamp
     *
     * domComplete_ts - Type: numeric. Desc: dom complete time stamp
     *
     * domLoading_ts - Type: numeric. Desc: dom loading time stamp
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * latency_ts - Type: numeric. Desc: latency time stamp
     *
     * bi_token - Type: guid.
     *
     * preRequest_ts - Type: numeric. Desc: pre request time stamp
     *
     * runPhase_ts - Type: numeric. Desc: run_phase time stamp
     *
     * serverResponse_ts - Type: numeric. Desc: server response time stamp
     *
     * startTime - Type: numeric. Desc: start time for iframe loading
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {pageLoadingTimeSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.pageLoadingTimeSf = function (params) {
        return this.bi.log(__assign({ evid: 861 }, params));
    };
    /**
    * @typedef {Object} clickOnProPlanUpgradeInComponentSettingParams
    * @property {string} appName - app_name
    * @property {string} component_id - CurrencyConverter, AvalaraTax, Subscription
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding / StoresBO
    * @property {GUID} storeId - store_id
    * @property {string} type - button / tooltip / banner
    **/
    /**
     * Name: High RPU -> Click on upgrade CTA. Evid: 845.
     * Event description: When a user clicks on the pro plan upgrade button in component setting (Can also be from GFPP) OR  When user clicks on Upgrade Now from button / popover / banner in Stores BO for High RPU feature.
    
     * appName - Type: string. Desc: app_name
     *
     * component_id - Type: string. Desc: CurrencyConverter, AvalaraTax, Subscription
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding / StoresBO
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: button / tooltip / banner
     * @param {clickOnProPlanUpgradeInComponentSettingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnProPlanUpgradeInComponentSetting = function (params) {
        return this.bi.log(__assign({ evid: 845 }, params));
    };
    /**
    * @typedef {Object} selectShippingMethodFromTheDropdownInCartPageSfParams
    * @property {string} appName - appName
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - is_merchant
    * @property {GUID} bi_token - msid
    * @property {string} orig_shipping_method - current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
    * @property {string} selected_shipping_method - the new shipping method that was selected from the dropdown in cart page  (free shipping/ Flat rate/ rate by weight/ etc...)
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Select shipping method from the dropdown in cart page SF. Evid: 222.
     * Event description: When a visitor clicks on one of the options in the shipping method dropdown on the cart page.
    
     * appName - Type: string. Desc: appName
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: is_merchant
     *
     * bi_token - Type: guid. Desc: msid
     *
     * orig_shipping_method - Type: string. Desc: current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
     *
     * selected_shipping_method - Type: string. Desc: the new shipping method that was selected from the dropdown in cart page  (free shipping/ Flat rate/ rate by weight/ etc...)
     *
     * storeId - Type: guid. Desc: store_id
     * @param {selectShippingMethodFromTheDropdownInCartPageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.selectShippingMethodFromTheDropdownInCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 222 }, params));
    };
    /**
    * @typedef {Object} clickOnContinueToPaymentSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} optionscount - number of delivery methods from which buyer choosed
    * @property {number} selectedoptionindex - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {string} methodType - pickup/not pickup
    * @property {GUID} bi_token - null
    * @property {string} orig_shipping_method - the shipping choice the buyer did in the cart
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {string} shippingRuleOptions - shipping method type- free shipping/ Flat rate/ rate by weight/ rate by order price/store pickup
    * @property {GUID} storeId - null
    * @property {string} selectedoptiontype - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Delivery method set SF. Evid: 163.
     * Event description: Click on continue to payment SF (on web) since june 2019 also sent from OneApp (leads to "Review Oreder" (placeOrder) screen).
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * optionscount - Type: numeric. Desc: number of delivery methods from which buyer choosed
     *
     * selectedoptionindex - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * methodType - Type: string. Desc: pickup/not pickup
     *
     * bi_token - Type: guid.
     *
     * orig_shipping_method - Type: string. Desc: the shipping choice the buyer did in the cart
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * shippingRuleOptions - Type: string. Desc: shipping method type- free shipping/ Flat rate/ rate by weight/ rate by order price/store pickup
     *
     * storeId - Type: guid.
     *
     * selectedoptiontype - Type: string.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {clickOnContinueToPaymentSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnContinueToPaymentSf = function (params) {
        return this.bi.log(__assign({ evid: 163 }, params));
    };
    /**
    * @typedef {Object} subscriptionsAreComingSoonVisitorPopupSfParams
    * @property {string} appName - app_name
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {string} origin - where the modal pops up (product page, product widget, gallery...)
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / live / preview
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Subscriptions are coming soon visitor popup SF. Evid: 457.
     * Event description: When a "subscriptions are coming soon" pop-up opens to the buyer. It happens when the user put on his store a subscription product, but doesn't have a premium..
    
     * appName - Type: string. Desc: app_name
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: where the modal pops up (product page, product widget, gallery...)
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / live / preview
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {subscriptionsAreComingSoonVisitorPopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.subscriptionsAreComingSoonVisitorPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 457 }, params));
    };
    /**
    * @typedef {Object} chooseLogicForSliderGalleryOnComponentSettingsSfeParams
    * @property {string} appName - app_name
    * @property {string} component_id - grid gallery, slider galery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - store_id
    * @property {GUID} userGuid - userGuid
    * @property {string} value - related products / collections
    **/
    /**
     * Name: Choose logic for slider gallery on component settings  SFE. Evid: 148.
     * Event description: click on one of the radio buttons to choose which logic to display in the slider gallery.
    
     * appName - Type: string. Desc: app_name
     *
     * component_id - Type: string. Desc: grid gallery, slider galery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid. Desc: store_id
     *
     * userGuid - Type: guid. Desc: userGuid
     *
     * value - Type: string. Desc: related products / collections
     * @param {chooseLogicForSliderGalleryOnComponentSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.chooseLogicForSliderGalleryOnComponentSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 148 }, params));
    };
    /**
    * @typedef {Object} saveNoteToSellerSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart id
    * @property {boolean} is_empty - is text field empty
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Save note to seller SF. Evid: 122.
     * Event description: buyer clicks on 'done' in add note to seller field in cart page. since june 2019 also sent from OA StoreFront (with origin).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart id
     *
     * is_empty - Type: bool. Desc: is text field empty
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {saveNoteToSellerSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.saveNoteToSellerSf = function (params) {
        return this.bi.log(__assign({ evid: 122 }, params));
    };
    /**
    * @typedef {Object} sortGallerySfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {string} method - price / newest / name
    * @property {GUID} bi_token - null
    * @property {string} sortDir - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Sort gallery SF. Evid: 13.
    
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * method - Type: string. Desc: price / newest / name
     *
     * bi_token - Type: guid.
     *
     * sortDir - Type: string.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {sortGallerySfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sortGallerySf = function (params) {
        return this.bi.log(__assign({ evid: 13 }, params));
    };
    /**
    * @typedef {Object} checkoutPageLoadSfParams
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {string} first_stage - first_stage_open in checkout page
    * @property {string} flowType - 'quick flow' / 'full flow'
    * @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant, false for member
    * @property {GUID} bi_token - msid
    * @property {number} num_of_shipping - number of shipping choices presented to the visitor
    * @property {string} origin - 'eWallet redirect - cancel' / 'eWallet redirect - continue' / 'cart' / 'product page' / 'product widget' / 'quick view'
    * @property {string} originType - origin type
    * @property {GUID} owner_id - uuid of site owner
    * @property {boolean} savedAddress - true if the member has saved address
    * @property {string} shippingMethodType - shipping /store pickup / none
    * @property {GUID} siteMemberId - member id
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Checkout page load SF. Evid: 36.
     * Event description: this event indicates witch "checkout page" was presented to the user. there are 6 types that depends on: 1.cart_type : Digital/ Physical/ mixed (Digital &Physical)  2. shipping method : shipping /store pickup / non. 3. flow_type: quick / full.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * first_stage - Type: string. Desc: first_stage_open in checkout page
     *
     * flowType - Type: string. Desc: 'quick flow' / 'full flow'
     *
     * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant, false for member
     *
     * bi_token - Type: guid. Desc: msid
     *
     * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor
     *
     * origin - Type: string. Desc: 'eWallet redirect - cancel' / 'eWallet redirect - continue' / 'cart' / 'product page' / 'product widget' / 'quick view'
     *
     * originType - Type: string. Desc: origin type
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * savedAddress - Type: bool. Desc: true if the member has saved address
     *
     * shippingMethodType - Type: string. Desc: shipping /store pickup / none
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {checkoutPageLoadSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.checkoutPageLoadSf = function (params) {
        return this.bi.log(__assign({ evid: 36 }, params));
    };
    /**
    * @typedef {Object} updateClickedInSelectYourShippingDestinationPopupSfParams
    * @property {string} appName - appName
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - is_merchant
    * @property {GUID} bi_token - null
    * @property {string} shippingDestinationCountry - shipping destination country
    * @property {string} shippingDestinationState - shipping destination state
    * @property {GUID} storeId - storeId
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: update clicked in select your shipping destination popup SF. Evid: 125.
     * Event description: in the cart page, when a user want to change is shipping address, to re calculate shipping cost estimation.
    
     * appName - Type: string. Desc: appName
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: is_merchant
     *
     * bi_token - Type: guid.
     *
     * shippingDestinationCountry - Type: string. Desc: shipping destination country
     *
     * shippingDestinationState - Type: string. Desc: shipping destination state
     *
     * storeId - Type: guid. Desc: storeId
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {updateClickedInSelectYourShippingDestinationPopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.updateClickedInSelectYourShippingDestinationPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 125 }, params));
    };
    /**
    * @typedef {Object} changeProductPageLayoutSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {string} editorMode - mobile / desktop
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {string} type - chosen layout
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change component layout SFE. Evid: 824.
     * Event description: user changed the product page layout in app settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * editorMode - Type: string. Desc: mobile / desktop
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: chosen layout
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeProductPageLayoutSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeProductPageLayoutSfe = function (params) {
        return this.bi.log(__assign({ evid: 824 }, params));
    };
    /**
    * @typedef {Object} changeProductPageDisplayedComponentsSfeParams
    * @property {string} action - checked / unchecked
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - null
    * @property {string} type - chosen layout
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change component displayed elements SFE. Evid: 825.
     * Event description: user checked/unchecked a displayed element in component in app settings.
    
     * action - Type: string. Desc: checked / unchecked
     *
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: chosen layout
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeProductPageDisplayedComponentsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeProductPageDisplayedComponentsSfe = function (params) {
        return this.bi.log(__assign({ evid: 825 }, params));
    };
    /**
    * @typedef {Object} thankYouPageLoadSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant
    * @property {GUID} bi_token - null
    * @property {number} numOfLineItems - number of uniq products
    * @property {string} orderId - order_id
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {string} paymentMethodType - online/offline
    * @property {string} paymentProvider - payment provider (paypal, strip....)
    * @property {string} payment_status - payment_status
    * @property {string} shippingMethodType - shipping /store pickup / non
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {string} viewMode - editor / site / preview
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Thank you page load SF. Evid: 174.
     * Event description: this event indicates witch "thank you page" was presented to the user. there are 10 types that depends on: 1.cart_type : Digital/ Physical/ mixed (Digital &Physical) 2.paymentMethodType : online/offline 3. shipping method : shipping /store pickup / non..
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant
     *
     * bi_token - Type: guid.
     *
     * numOfLineItems - Type: numeric. Desc: number of uniq products
     *
     * orderId - Type: string. Desc: order_id
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * paymentMethodType - Type: string. Desc: online/offline
     *
     * paymentProvider - Type: string. Desc: payment provider (paypal, strip....)
     *
     * payment_status - Type: string. Desc: payment_status
     *
     * shippingMethodType - Type: string. Desc: shipping /store pickup / non
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * viewMode - Type: string. Desc: editor / site / preview
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {thankYouPageLoadSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thankYouPageLoadSf = function (params) {
        return this.bi.log(__assign({ evid: 174 }, params));
    };
    /**
    * @typedef {Object} giftCardCheckoutRemoveCodeParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {string} giftCardId - null
    * @property {boolean} isMember - true if visitor is member
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} siteMemberId - null
    * @property {GUID} storeId - store_id
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: gift card checkout -> remove Code. Evid: 536.
     * Event description: when visitor clicks "remove" after applying Gift Card Codein Payment stage of Checkout.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * giftCardId - Type: string.
     *
     * isMember - Type: bool. Desc: true if visitor is member
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * siteMemberId - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     *
     * visitor_id - Type: guid.
     * @param {giftCardCheckoutRemoveCodeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.giftCardCheckoutRemoveCode = function (params) {
        return this.bi.log(__assign({ evid: 536 }, params));
    };
    /**
    * @typedef {Object} addCustomFilterSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider gallery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: Add custom filter SFE. Evid: 839.
     * Event description: add custom filter- right now it is for collections filter only.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider gallery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {addCustomFilterSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addCustomFilterSfe = function (params) {
        return this.bi.log(__assign({ evid: 839 }, params));
    };
    /**
    * @typedef {Object} selectPaymentCategorySfCashierParams
    * @property {GUID} app_instance_id - store_Id
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} paymentCategory - CreditCard/Ewallet
    * @property {string} paymentMethod - authorize-net/Stripe
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Select payment category SF cashier. Evid: 200.
     * Event description: Select payment category SF cashier - select radio button.
    
     * app_instance_id - Type: guid. Desc: store_Id
     *
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * paymentCategory - Type: string. Desc: CreditCard/Ewallet
     *
     * paymentMethod - Type: string. Desc: authorize-net/Stripe
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {selectPaymentCategorySfCashierParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.selectPaymentCategorySfCashier = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} migrationClickOnMigrationPopUpParams
    * @property {string} appName - appname
    * @property {GUID} button_type - blank
    * @property {string} button_name - learn_more / close / switch_now / got_it
    * @property {boolean} isMerchant - isMerchant status
    * @property {string} magentoStoreId - magento store id (As a string)
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: migration - click on migration pop-up. Evid: 302.
     * Event description: click on migration pop up that shown for the owners of eligible to migration stores every time they enter the old WYSIWYG editor..
    
     * appName - Type: string. Desc: appname
     *
     * button_type - Type: guid. Desc: blank
     *
     * button_name - Type: string. Desc: learn_more / close / switch_now / got_it
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * magentoStoreId - Type: string. Desc: magento store id (As a string)
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {migrationClickOnMigrationPopUpParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.migrationClickOnMigrationPopUp = function (params) {
        return this.bi.log(__assign({ evid: 302 }, params));
    };
    /**
    * @typedef {Object} showMerchantUpgradePopupSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {string} mode - null
    * @property {GUID} bi_token - null
    * @property {string} origin - where the modal pops up (cart / product page...)
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Show merchant upgrade popup SF. Evid: 165.
    
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * mode - Type: string.
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: where the modal pops up (cart / product page...)
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {showMerchantUpgradePopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.showMerchantUpgradePopupSf = function (params) {
        return this.bi.log(__assign({ evid: 165 }, params));
    };
    /**
    * @typedef {Object} linkChangedInSettingsSfeParams
    * @property {string} appName - app name
    * @property {string} component_id - thank you page / cart page / my orders
    * @property {string} element - continue shopping / empty state / back to store
    * @property {string} value - deprecated
    * @property {boolean} isMerchant - isMerchant status
    * @property {string} link - new link changed
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Link changed in settings SFE. Evid: 197.
     * Event description: when the link changed in the settings of the cart or the thank you page / my orders.
    
     * appName - Type: string. Desc: app name
     *
     * component_id - Type: string. Desc: thank you page / cart page / my orders
     *
     * element - Type: string. Desc: continue shopping / empty state / back to store
     *
     * value - Type: string. Desc: deprecated
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * link - Type: string. Desc: new link changed
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     * @param {linkChangedInSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.linkChangedInSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 197 }, params));
    };
    /**
    * @typedef {Object} paymentDetailsCompletedSfParams
    * @property {string} appName - appname
    * @property {GUID} cartId - cartid
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} optionscount - number of payment options
    * @property {number} selectedoptionindex - index of selected option
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true is it is owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {string} paymentProvider - payment provider that was chosen
    * @property {GUID} storeId - store_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Payment details completed SF. Evid: 177.
     * Event description: UoU clicked continue on payment details step in new checkout funnel. since june 2019 also sent from OA StoreFront (with origin).
    
     * appName - Type: string. Desc: appname
     *
     * cartId - Type: guid. Desc: cartid
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * optionscount - Type: numeric. Desc: number of payment options
     *
     * selectedoptionindex - Type: numeric. Desc: index of selected option
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true is it is owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * paymentProvider - Type: string. Desc: payment provider that was chosen
     *
     * storeId - Type: guid. Desc: store_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {paymentDetailsCompletedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.paymentDetailsCompletedSf = function (params) {
        return this.bi.log(__assign({ evid: 177 }, params));
    };
    /**
    * @typedef {Object} logoutModalInCheckoutLoadedSfParams
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {string} flowType - 'quick flow' / 'full flow'
    * @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {boolean} savedAddress - true if the member has saved address
    * @property {GUID} siteMemberId - member id
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: logout modal in checkout loaded  SF. Evid: 602.
     * Event description: logout modal loaded in checkout after member presses logout.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * flowType - Type: string. Desc: 'quick flow' / 'full flow'
     *
     * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * savedAddress - Type: bool. Desc: true if the member has saved address
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: store_id
     * @param {logoutModalInCheckoutLoadedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.logoutModalInCheckoutLoadedSf = function (params) {
        return this.bi.log(__assign({ evid: 602 }, params));
    };
    /**
    * @typedef {Object} zoomModalIsClosedSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product has options
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Zoom modal is closed SF. Evid: 492.
     * Event description: When the zoom modal in product page is closed by clicking on the X or swiping up / down.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product has options
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     * @param {zoomModalIsClosedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.zoomModalIsClosedSf = function (params) {
        return this.bi.log(__assign({ evid: 492 }, params));
    };
    /**
    * @typedef {Object} clickOnLeftBarTabsOnComponentSettingsSfeParams
    * @property {string} appName - app_name
    * @property {string} component_id - grid gallery, slider galeery, product page, CurrencyConverter
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isPremiumEligible - Does the site have a premium package that allows using the feature (if not relevant null)
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - store_id
    * @property {string} tab - design / text / Manage
    **/
    /**
     * Name: click on left bar tabs on component settings  SFE. Evid: 33.
     * Event description: click to view tab in the settings component (left bar).
    
     * appName - Type: string. Desc: app_name
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page, CurrencyConverter
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isPremiumEligible - Type: bool. Desc: Does the site have a premium package that allows using the feature (if not relevant null)
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid. Desc: store_id
     *
     * tab - Type: string. Desc: design / text / Manage
     * @param {clickOnLeftBarTabsOnComponentSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnLeftBarTabsOnComponentSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 33 }, params));
    };
    /**
    * @typedef {Object} clickOnProductOptionSfParams
    * @property {string} action - checked / unchecked
    * @property {string} appName - app_name
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {string} optiontype - list / color
    * @property {string} origin - product-page / gallery-page / slider-gallery / quick-view
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: click on product option SF. Evid: 486.
     * Event description: buyer clicks to choose a product option (color / list) on product page, gallery or quickView.
    
     * action - Type: string. Desc: checked / unchecked
     *
     * appName - Type: string. Desc: app_name
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * optiontype - Type: string. Desc: list / color
     *
     * origin - Type: string. Desc: product-page / gallery-page / slider-gallery / quick-view
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {clickOnProductOptionSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnProductOptionSf = function (params) {
        return this.bi.log(__assign({ evid: 486 }, params));
    };
    /**
    * @typedef {Object} productRemovedFromWishlistSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product have options
    * @property {boolean} hasRibbon - does the product have ribbon
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - null
    * @property {string} origin - product-page / gallery-page / quick-view / product-widget
    * @property {GUID} owner_id - id of site's owner. since june 2019
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: Product removed from wishlist SF. Evid: 268.
     * Event description: when a product was successfully removed from wishlist after the buyer clicks on button.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product have options
     *
     * hasRibbon - Type: bool. Desc: does the product have ribbon
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: product-page / gallery-page / quick-view / product-widget
     *
     * owner_id - Type: guid. Desc: id of site's owner. since june 2019
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {productRemovedFromWishlistSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.productRemovedFromWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 268 }, params));
    };
    /**
    * @typedef {Object} removeACouponSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} couponCode - null
    * @property {string} couponId - null
    * @property {boolean} isMember - is_member
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Remove a coupon SF. Evid: 118.
    
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * couponCode - Type: string.
     *
     * couponId - Type: string.
     *
     * isMember - Type: bool. Desc: is_member
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {removeACouponSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.removeACouponSf = function (params) {
        return this.bi.log(__assign({ evid: 118 }, params));
    };
    /**
    * @typedef {Object} viewStoresPanelInEditorParams
    * @property {string} actions - json with all the quick actions the user sees
    * @property {string} app_id - stores app_id
    * @property {string} appName - WixStores
    * @property {GUID} esi - esi
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} site_id - site_id
    * @property {string} state - what does the user sees when the panel is open
    * @property {GUID} storeId - null
    * @property {string} type - automatic open / click on button
    * @property {string} viewMode - DESKTOP etc.
    **/
    /**
     * Name: View Stores Panel in Editor. Evid: 810.
     * Event description: When the Stores panel is open in the Editor.
    
     * actions - Type: string. Desc: json with all the quick actions the user sees
     *
     * app_id - Type: string. Desc: stores app_id
     *
     * appName - Type: string. Desc: WixStores
     *
     * esi - Type: guid. Desc: esi
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * site_id - Type: guid. Desc: site_id
     *
     * state - Type: string. Desc: what does the user sees when the panel is open
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: automatic open / click on button
     *
     * viewMode - Type: string. Desc: DESKTOP etc.
     * @param {viewStoresPanelInEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewStoresPanelInEditor = function (params) {
        return this.bi.log(__assign({ evid: 810 }, params));
    };
    /**
    * @typedef {Object} clickOnShippingDestinationInCartPageSfParams
    * @property {string} appName - appName
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - is_merchant
    * @property {GUID} bi_token - msid
    * @property {string} shippingDestinationCountry - shipping destination country
    * @property {string} shippingDestinationState - shipping destination state
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click on shipping destination in cart page SF. Evid: 223.
     * Event description: When a visitor clicks to change the shipping destination on the cart page.
    
     * appName - Type: string. Desc: appName
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: is_merchant
     *
     * bi_token - Type: guid. Desc: msid
     *
     * shippingDestinationCountry - Type: string. Desc: shipping destination country
     *
     * shippingDestinationState - Type: string. Desc: shipping destination state
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickOnShippingDestinationInCartPageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnShippingDestinationInCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 223 }, params));
    };
    /**
    * @typedef {Object} viewZoomModalSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product has options
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: View zoom modal SF. Evid: 491.
     * Event description: When the zoom modal in product page loads.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product has options
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     * @param {viewZoomModalSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewZoomModalSf = function (params) {
        return this.bi.log(__assign({ evid: 491 }, params));
    };
    /**
    * @typedef {Object} changeImageRatioInGallerySfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {string} imageRatio - selected image ratio (2X2. 2X3...)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change image ratio in gallery SFE. Evid: 815.
     * Event description: change image ratio in gallery.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * imageRatio - Type: string. Desc: selected image ratio (2X2. 2X3...)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeImageRatioInGallerySfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeImageRatioInGallerySfe = function (params) {
        return this.bi.log(__assign({ evid: 815 }, params));
    };
    /**
    * @typedef {Object} highRpuFeatureAdAssetShownParams
    * @property {string} appName - app_name
    * @property {string} component_id - CurrencyConverter, AvalaraTax, Subscription
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {string} origin - editor / onboarding / StoresBO / Live site
    * @property {string} paymentStatus - the merchant payment connection status. no payment / both / only payment
    * @property {GUID} storeId - store_id
    * @property {string} type - banner / tooltip / UoU popup
    **/
    /**
     * Name: High RPU -> Feature Ad asset shown. Evid: 236.
     * Event description: when Ad asset (e.g. banner, tooltip) to Upgrade to High ARPU to get feature is shown.
    
     * appName - Type: string. Desc: app_name
     *
     * component_id - Type: string. Desc: CurrencyConverter, AvalaraTax, Subscription
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: editor / onboarding / StoresBO / Live site
     *
     * paymentStatus - Type: string. Desc: the merchant payment connection status. no payment / both / only payment
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: banner / tooltip / UoU popup
     * @param {highRpuFeatureAdAssetShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.highRpuFeatureAdAssetShown = function (params) {
        return this.bi.log(__assign({ evid: 236 }, params));
    };
    /**
    * @typedef {Object} clickLoadMoreInGallerySfParams
    * @property {string} appName - app_name
    * @property {GUID} categoryId - category_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    * @property {string} type - button / pagination
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Click to load more in gallery SF. Evid: 14.
     * Event description: when a buyer clicks to view more products in the gallery (load more/next page/ etc.).
    
     * appName - Type: string. Desc: app_name
     *
     * categoryId - Type: guid. Desc: category_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: button / pagination
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {clickLoadMoreInGallerySfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickLoadMoreInGallerySf = function (params) {
        return this.bi.log(__assign({ evid: 14 }, params));
    };
    /**
    * @typedef {Object} viewOrderDetailsPageSfParams
    * @property {string} appName - appName
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {string} contact_id - contact_id
    * @property {number} itemsCount - number of items in the order
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} orderId - orderId
    * @property {string} origin - order_page
    * @property {GUID} site_member_id - member id
    * @property {GUID} storeId - instance id
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: view order_details page SF. Evid: 128.
     * Event description: view order details in order history page.
    
     * appName - Type: string. Desc: appName
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * contact_id - Type: string. Desc: contact_id
     *
     * itemsCount - Type: numeric. Desc: number of items in the order
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * orderId - Type: string. Desc: orderId
     *
     * origin - Type: string. Desc: order_page
     *
     * site_member_id - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: instance id
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {viewOrderDetailsPageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewOrderDetailsPageSf = function (params) {
        return this.bi.log(__assign({ evid: 128 }, params));
    };
    /**
    * @typedef {Object} clickOnViewItemsInReviewOrderScreenOaStoreFrontParams
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click on "View items" in Review order screen OA StoreFront. Evid: 186.
     * Event description: buyer in OneApp StoreFront (member view) in checkout on review order (place order in other words) stage clicks on View items(leads to open "Your items" screen - entry point to edit cart).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickOnViewItemsInReviewOrderScreenOaStoreFrontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnViewItemsInReviewOrderScreenOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 186 }, params));
    };
    /**
    * @typedef {Object} shippingAddressSetSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isChecked - is billing address the same as delivery address
    * @property {boolean} isFormValid - is form valid (all mandatory fields are compatible)
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - uuid of merchant
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Shipping address set SF. Evid: 161.
     * Event description: Shipping address set SF. since june 2019 is also sentt from OneApp (origin =OA StoreFront).
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isChecked - Type: bool. Desc: is billing address the same as delivery address
     *
     * isFormValid - Type: bool. Desc: is form valid (all mandatory fields are compatible)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: uuid of merchant
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {shippingAddressSetSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.shippingAddressSetSf = function (params) {
        return this.bi.log(__assign({ evid: 161 }, params));
    };
    /**
    * @typedef {Object} clickOnCartIconToOpenMiniCartSfParams
    * @property {string} appName - app
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isNavigateCart - hard coded false (for Anodot)
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: Click on cart icon to open mini cart SF. Evid: 49.
     * Event description: click on cart icon to open the mini cart.
    
     * appName - Type: string. Desc: app
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isNavigateCart - Type: bool. Desc: hard coded false (for Anodot)
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {clickOnCartIconToOpenMiniCartSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnCartIconToOpenMiniCartSf = function (params) {
        return this.bi.log(__assign({ evid: 49 }, params));
    };
    /**
    * @typedef {Object} thankYouPageContinueShoppingClickedSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} orderId - orderId
    * @property {GUID} storeId - null
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: Thank you page Continue Shopping clicked SF. Evid: 176.
     * Event description: buyer clicked on download file  in Thank you page.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * orderId - Type: string. Desc: orderId
     *
     * storeId - Type: guid.
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {thankYouPageContinueShoppingClickedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.thankYouPageContinueShoppingClickedSf = function (params) {
        return this.bi.log(__assign({ evid: 176 }, params));
    };
    /**
    * @typedef {Object} errorInAddProductToCartOneAppStoreFrontParams
    * @property {string} appName - null
    * @property {string} field - list of invalid fields (comma delimited) from quantity / product_options / custom_field
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - is_owner
    * @property {string} message - validation error
    * @property {GUID} bi_token - msid
    * @property {GUID} owner_id - owner_id
    * @property {string} productId - product_guid
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Error in add product to cart OneApp StoreFront. Evid: 183.
     * Event description: when buyer clicked "Add to Cart" in product page but it doesn't work because buyer didn't selected product option / custom field / product with this product options is out of stock (if the quantity of selected).
    
     * appName - Type: string.
     *
     * field - Type: string. Desc: list of invalid fields (comma delimited) from quantity / product_options / custom_field
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * message - Type: string. Desc: validation error
     *
     * bi_token - Type: guid. Desc: msid
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * productId - Type: string. Desc: product_guid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {errorInAddProductToCartOneAppStoreFrontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.errorInAddProductToCartOneAppStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 183 }, params));
    };
    /**
    * @typedef {Object} cartWidgetLoadedSfParams
    * @property {string} appName - fucj
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Mini Cart loaded SF. Evid: 211.
    
    
     * appName - Type: string. Desc: fucj
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {cartWidgetLoadedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cartWidgetLoadedSf = function (params) {
        return this.bi.log(__assign({ evid: 211 }, params));
    };
    /**
    * @typedef {Object} clickOnImageOfProductOaParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - msid
    * @property {string} productId - product_id of main product
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Click on image of product OA SF. Evid: 232.
     * Event description: member clicked on image in product screen OA SF (opens gallery).
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid. Desc: msid
     *
     * productId - Type: string. Desc: product_id of main product
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {clickOnImageOfProductOaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnImageOfProductOa = function (params) {
        return this.bi.log(__assign({ evid: 232 }, params));
    };
    /**
    * @typedef {Object} cancelClickedInSelectYourShippingDestinationPopupSfParams
    * @property {string} appName - appName
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - is_merchant
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - storeId
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: cancel clicked in select your shipping destination popup SF. Evid: 126.
     * Event description: in the cart page, when a user want to change is shipping address, to re calculate shipping cost estimation- cancel or x clicked.
    
     * appName - Type: string. Desc: appName
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: is_merchant
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: storeId
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {cancelClickedInSelectYourShippingDestinationPopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cancelClickedInSelectYourShippingDestinationPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 126 }, params));
    };
    /**
    * @typedef {Object} showHideFiltersSortingSfeParams
    * @property {string} action - checked / unchecked
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider gallery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {string} type - sorting options / filters
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: show/hide filters/sorting SFE. Evid: 835.
     * Event description: check/uncheck show all filters or sorting options in the 'sorting & filters' tab.
    
     * action - Type: string. Desc: checked / unchecked
     *
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider gallery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: sorting options / filters
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {showHideFiltersSortingSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.showHideFiltersSortingSfe = function (params) {
        return this.bi.log(__assign({ evid: 835 }, params));
    };
    /**
    * @typedef {Object} clickOnEditProductsInProductWidgetSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galery, product page, product widget
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: click on edit products in product widget SFE. Evid: 827.
     * Event description: merchant clicks on edit products in product widget settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galery, product page, product widget
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {clickOnEditProductsInProductWidgetSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnEditProductsInProductWidgetSfe = function (params) {
        return this.bi.log(__assign({ evid: 827 }, params));
    };
    /**
    * @typedef {Object} clickOnProductBoxSfParams
    * @property {string} appName - null
    * @property {boolean} hasOptions - null
    * @property {boolean} hasRibbon - null
    * @property {number} index - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for owner and false for member
    * @property {GUID} bi_token - null
    * @property {string} origin - catalog_OA / cart_OA (from OneApp Stores front) / quick-view
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} productId - null
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click to View Product SF. Evid: 11.
     * Event description: sent from web from product gallery. also since june 2019 started to be sent from OneApp Store Front (member view).
    
     * appName - Type: string.
     *
     * hasOptions - Type: bool.
     *
     * hasRibbon - Type: bool.
     *
     * index - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for owner and false for member
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: catalog_OA / cart_OA (from OneApp Stores front) / quick-view
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * productId - Type: string.
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {clickOnProductBoxSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnProductBoxSf = function (params) {
        return this.bi.log(__assign({ evid: 11 }, params));
    };
    /**
    * @typedef {Object} proPlanUpgradeModalLoadedParams
    * @property {string} appName - null
    * @property {string} component_id - From which component the modal was opened (
    CurrencyConverter, AvalaraTax, subscriptions)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding / StoresBO
    * @property {GUID} storeId - store_id
    * @property {string} type - button / tooltip / banner
    **/
    /**
     * Name: High RPU -> Upgrade modal loaded. Evid: 846.
     * Event description: when the pro plan upgrade modal is loaded in the editor/ADI OR when in Stores BO Upgrade modal loaded for High RPU.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: From which component the modal was opened (
    CurrencyConverter, AvalaraTax, subscriptions)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding / StoresBO
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: button / tooltip / banner
     * @param {proPlanUpgradeModalLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.proPlanUpgradeModalLoaded = function (params) {
        return this.bi.log(__assign({ evid: 846 }, params));
    };
    /**
    * @typedef {Object} clickOnQuickActionStoresPanelInEditorParams
    * @property {string} app_id - stores app_id
    * @property {string} appName - WixStores
    * @property {string} buttonName - name of the button (find products,add payment...)
    * @property {GUID} esi - esi
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {string} origin - the state of the panel when the user clicked on the button
    * @property {GUID} site_id - site_id
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - DESKTOP etc.
    **/
    /**
     * Name: Click on QuickAction Stores Panel in Editor. Evid: 850.
     * Event description: When the user clicks on one of the quick actions in the Stores 6th button in the editor.
    
     * app_id - Type: string. Desc: stores app_id
     *
     * appName - Type: string. Desc: WixStores
     *
     * buttonName - Type: string. Desc: name of the button (find products,add payment...)
     *
     * esi - Type: guid. Desc: esi
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: the state of the panel when the user clicked on the button
     *
     * site_id - Type: guid. Desc: site_id
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: DESKTOP etc.
     * @param {clickOnQuickActionStoresPanelInEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnQuickActionStoresPanelInEditor = function (params) {
        return this.bi.log(__assign({ evid: 850 }, params));
    };
    /**
    * @typedef {Object} clickOnProductDetailsSfParams
    * @property {string} appName - null
    * @property {number} index - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} productId - null
    * @property {GUID} storeId - null
    * @property {string} type - product details type (tab, expand...)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click on product details SF. Evid: 61.
     * Event description: When clicking a product info title in the product page.
    
     * appName - Type: string.
     *
     * index - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * productId - Type: string.
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: product details type (tab, expand...)
     *
     * visitor_id - Type: guid.
     * @param {clickOnProductDetailsSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnProductDetailsSf = function (params) {
        return this.bi.log(__assign({ evid: 61 }, params));
    };
    /**
    * @typedef {Object} clickLogoutInCheckoutSfParams
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {string} flowType - 'quick flow' / 'full flow'
    * @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {boolean} savedAddress - true if the member has saved address
    * @property {GUID} siteMemberId - member id
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: click logout in checkout SF. Evid: 601.
     * Event description: when  site member clicks to logout in checkout, opening logout modal.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * flowType - Type: string. Desc: 'quick flow' / 'full flow'
     *
     * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * savedAddress - Type: bool. Desc: true if the member has saved address
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickLogoutInCheckoutSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickLogoutInCheckoutSf = function (params) {
        return this.bi.log(__assign({ evid: 601 }, params));
    };
    /**
    * @typedef {Object} oneAppStoreFrontClearCartSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {number} itemsCount - # of products in cart
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true  - for merchant false for member
    * @property {GUID} bi_token - msid
    * @property {GUID} owner_id - uuid of site owner
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: OneApp StoreFront -> Clear cart SF. Evid: 184.
     * Event description: buyer cleared cart (in cart page from 3dots menu) after it the cart becomes innactive (will get neww cart_id).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * itemsCount - Type: numeric. Desc: # of products in cart
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true  - for merchant false for member
     *
     * bi_token - Type: guid. Desc: msid
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {oneAppStoreFrontClearCartSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oneAppStoreFrontClearCartSf = function (params) {
        return this.bi.log(__assign({ evid: 184 }, params));
    };
    /**
    * @typedef {Object} productOptionsDeleteOptionFromCatalogParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {string} productId - product_id
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: product options - delete option from catalog. Evid: 32.
     * Event description: when user click to delete an option from the catalog (in manage all product options menu).
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * productId - Type: string. Desc: product_id
     *
     * storeId - Type: guid. Desc: store_id
     * @param {productOptionsDeleteOptionFromCatalogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.productOptionsDeleteOptionFromCatalog = function (params) {
        return this.bi.log(__assign({ evid: 32 }, params));
    };
    /**
    * @typedef {Object} applyACouponSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} couponCode - null
    * @property {string} couponId - null
    * @property {boolean} isMember - is_member
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} name - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {GUID} storeId - null
    * @property {number} total_long - amount of coupon INTEGER (multiplied by 1000000)
    * @property {number} total - null
    * @property {string} type - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Coupon applied SF. Evid: 119.
    
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * couponCode - Type: string.
     *
     * couponId - Type: string.
     *
     * isMember - Type: bool. Desc: is_member
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * name - Type: string.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * storeId - Type: guid.
     *
     * total_long - Type: numeric. Desc: amount of coupon INTEGER (multiplied by 1000000)
     *
     * total - Type: numeric.
     *
     * type - Type: string.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {applyACouponSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.applyACouponSf = function (params) {
        return this.bi.log(__assign({ evid: 119 }, params));
    };
    /**
    * @typedef {Object} clickOnEditElementSettingsSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {string} element - product image, name&price&sku, product options&quantity, button, info sections, social media
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: click on edit element settings SFE. Evid: 830.
     * Event description: click on edit elements settings in product page settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * element - Type: string. Desc: product image, name&price&sku, product options&quantity, button, info sections, social media
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {clickOnEditElementSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnEditElementSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 830 }, params));
    };
    /**
    * @typedef {Object} giftCardCheckoutCodeAppliedParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {string} giftCardId - gift_card_id
    * @property {boolean} isCartPaidOnlyWithGiftCard - True if payments options are hidden due to gift card fully cover the payment (with coupon or without)
    * @property {boolean} isMember - true if visitor is member
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} siteMemberId - member
    * @property {GUID} storeId - store_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: gift card checkout -> code applied. Evid: 535.
     * Event description: when Gift Card Code was successfully applied in Payment stage of Checkout.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * giftCardId - Type: string. Desc: gift_card_id
     *
     * isCartPaidOnlyWithGiftCard - Type: bool. Desc: True if payments options are hidden due to gift card fully cover the payment (with coupon or without)
     *
     * isMember - Type: bool. Desc: true if visitor is member
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * siteMemberId - Type: guid. Desc: member
     *
     * storeId - Type: guid. Desc: store_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {giftCardCheckoutCodeAppliedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.giftCardCheckoutCodeApplied = function (params) {
        return this.bi.log(__assign({ evid: 535 }, params));
    };
    /**
    * @typedef {Object} clickToOpenZoomModalSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product has options
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click to open zoom modal SF. Evid: 490.
     * Event description: When a buyer clicks on product image in product page to open zoom modal.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product has options
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickToOpenZoomModalSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToOpenZoomModalSf = function (params) {
        return this.bi.log(__assign({ evid: 490 }, params));
    };
    /**
    * @typedef {Object} clickOnBackToPaypalSfParams
    * @property {string} appName - appName
    * @property {string} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} orig_shipping_method - the shipping method that the visitor choose in the cart - free shipping/ Flat rate/ rate by weight/ rate by order price/store pickup (the same strings as in 163 event)
    * @property {GUID} storeId - storeId
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Click on Back to Paypal SF. Evid: 160.
     * Event description: buyer clicks on 'back to PayPal' in shipping screen in checkout.
    
     * appName - Type: string. Desc: appName
     *
     * cartId - Type: string. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * orig_shipping_method - Type: string. Desc: the shipping method that the visitor choose in the cart - free shipping/ Flat rate/ rate by weight/ rate by order price/store pickup (the same strings as in 163 event)
     *
     * storeId - Type: guid. Desc: storeId
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {clickOnBackToPaypalSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnBackToPaypalSf = function (params) {
        return this.bi.log(__assign({ evid: 160 }, params));
    };
    /**
    * @typedef {Object} clickOnEditCartSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - page in checkout (delivery, payment...)
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: click on edit cart SF. Evid: 171.
     * Event description: click on edit cart button in checkout process.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: page in checkout (delivery, payment...)
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {clickOnEditCartSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnEditCartSf = function (params) {
        return this.bi.log(__assign({ evid: 171 }, params));
    };
    /**
    * @typedef {Object} changeGalleryCollectionSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change gallery collection SFE. Evid: 813.
     * Event description: change gallery collection for display.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeGalleryCollectionSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeGalleryCollectionSfe = function (params) {
        return this.bi.log(__assign({ evid: 813 }, params));
    };
    /**
    * @typedef {Object} viewStorePageSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} pageId - page name - thank you page / product page...
    * @property {GUID} storeId - null
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: view store page SF. Evid: 17.
     * Event description: view store page in viewer.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * pageId - Type: string. Desc: page name - thank you page / product page...
     *
     * storeId - Type: guid.
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {viewStorePageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewStorePageSf = function (params) {
        return this.bi.log(__assign({ evid: 17 }, params));
    };
    /**
    * @typedef {Object} changeCartIconSfeParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - null
    * @property {string} type - icon type
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change cart icon SFE. Evid: 820.
     * Event description: select a cart icon in mini cart settings.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: icon type
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeCartIconSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeCartIconSfe = function (params) {
        return this.bi.log(__assign({ evid: 820 }, params));
    };
    /**
    * @typedef {Object} clickOnChangeLinkInSettingsSfeParams
    * @property {string} appName - app name
    * @property {string} component_id - thank you page / cart page / my orders
    * @property {string} element - continue shopping / empty state / back to store
    * @property {boolean} isMerchant - isMerchant status
    * @property {string} link - current navigation link
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click on change link in settings SFE. Evid: 196.
     * Event description: when the user click on the change link in the settings of the cart or the thank you page / my orders.
    
     * appName - Type: string. Desc: app name
     *
     * component_id - Type: string. Desc: thank you page / cart page / my orders
     *
     * element - Type: string. Desc: continue shopping / empty state / back to store
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * link - Type: string. Desc: current navigation link
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickOnChangeLinkInSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnChangeLinkInSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 196 }, params));
    };
    /**
    * @typedef {Object} clickOnAddNoteToSellerSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart id
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} storeId - null
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Click on add note to seller SF. Evid: 121.
     * Event description: buyer clicks on 'add note to seller' in cart page. since june 2019 also sent from OA StoreFront (with origin).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * storeId - Type: guid.
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {clickOnAddNoteToSellerSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnAddNoteToSellerSf = function (params) {
        return this.bi.log(__assign({ evid: 121 }, params));
    };
    /**
    * @typedef {Object} notAcceptPaymentsVisitorPopupSfParams
    * @property {string} appName - app_name
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - where the modal pops up (cart / product page...)
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / live / preview
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Not able to accept payments visitor popup SF. Evid: 283.
     * Event description: Error pop-up opens when the buyer clicks on one of the checkout buttons, and If the store can't accept orders (not an Active Store / doesn't have any shipping rules)..
    
     * appName - Type: string. Desc: app_name
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: where the modal pops up (cart / product page...)
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / live / preview
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {notAcceptPaymentsVisitorPopupSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notAcceptPaymentsVisitorPopupSf = function (params) {
        return this.bi.log(__assign({ evid: 283 }, params));
    };
    /**
    * @typedef {Object} logoutModalInCheckoutClosedSfParams
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {string} flowType - 'quick flow' / 'full flow'
    * @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {boolean} savedAddress - true if the member has saved address
    * @property {GUID} siteMemberId - member id
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click on return to checkout in logout modal SF. Evid: 603.
     * Event description: buyer clicks on "return to checkout" or X in logout modal in checkout to close it.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * flowType - Type: string. Desc: 'quick flow' / 'full flow'
     *
     * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * savedAddress - Type: bool. Desc: true if the member has saved address
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: store_id
     * @param {logoutModalInCheckoutClosedSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.logoutModalInCheckoutClosedSf = function (params) {
        return this.bi.log(__assign({ evid: 603 }, params));
    };
    /**
    * @typedef {Object} clickAddToWishlistSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product have options
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - null
    * @property {string} origin - product-page / gallery-page / quick-view / product-widget
    * @property {GUID} owner_id - id of site's owner. since june 2019
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: Click add to wishlist SF. Evid: 260.
     * Event description: buyer clicks on to add product to wishlist.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product have options
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: product-page / gallery-page / quick-view / product-widget
     *
     * owner_id - Type: guid. Desc: id of site's owner. since june 2019
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {clickAddToWishlistSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickAddToWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 260 }, params));
    };
    /**
    * @typedef {Object} wishlistInstallationStageParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {string} stage - which stage in the wishlist installation process
    * @property {GUID} storeId - null
    **/
    /**
     * Name: wishlist installation stage. Evid: 844.
     * Event description: wishlist installation stage.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * stage - Type: string. Desc: which stage in the wishlist installation process
     *
     * storeId - Type: guid.
     * @param {wishlistInstallationStageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.wishlistInstallationStage = function (params) {
        return this.bi.log(__assign({ evid: 844 }, params));
    };
    /**
    * @typedef {Object} membersAddressInCheckoutWasChangedParams
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {string} origin - addresses list / add address / edit address
    * @property {GUID} siteMemberId - member id
    * @property {string} stage - page in checkout (delivery, payment...)
    * @property {GUID} storeId - store_id
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: members -> address in checkout was changed. Evid: 48.
     * Event description: when address was changed in the checkout.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: addresses list / add address / edit address
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * stage - Type: string. Desc: page in checkout (delivery, payment...)
     *
     * storeId - Type: guid. Desc: store_id
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {membersAddressInCheckoutWasChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.membersAddressInCheckoutWasChanged = function (params) {
        return this.bi.log(__assign({ evid: 48 }, params));
    };
    /**
    * @typedef {Object} clickOnBackInCheckoutProcessSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart id
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} owner_id - owner_id
    * @property {string} previousStage - the closed stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
    * @property {string} stage - delivery options, payment
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: click on 'back' in checkout process SF. Evid: 170.
     * Event description: click on 'back' or 'edit' in checkout process. since june 2019 also sent from OneApp.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * previousStage - Type: string. Desc: the closed stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
     *
     * stage - Type: string. Desc: delivery options, payment
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {clickOnBackInCheckoutProcessSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnBackInCheckoutProcessSf = function (params) {
        return this.bi.log(__assign({ evid: 170 }, params));
    };
    /**
    * @typedef {Object} clickPlaceOrderWithSubscriptionParams
    * @property {string} appName - null
    * @property {GUID} cartId - cartId
    * @property {boolean} default_state - true if was turned on by default by merchant settings
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - null
    * @property {string} origin - OA StoreFront
    * @property {GUID} storeId - storeId
    **/
    /**
     * Name: Click Place order with Subscription. Evid: 58.
     * Event description: if "Subscription" checkbox was checked on clicking on place order (client event). since june 2019 also sent from OA StoreFront (with origin).
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cartId
     *
     * default_state - Type: bool. Desc: true if was turned on by default by merchant settings
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: OA StoreFront
     *
     * storeId - Type: guid. Desc: storeId
     * @param {clickPlaceOrderWithSubscriptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickPlaceOrderWithSubscription = function (params) {
        return this.bi.log(__assign({ evid: 58 }, params));
    };
    /**
    * @typedef {Object} openAppSettingsSfeParams
    * @property {string} appName - app name
    * @property {string} component_id - grid gallery, slider galeery, product page, CurrencyConverter
    * @property {string} editorMode - mobile / desktop
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isPremiumEligible - Does the site have a premium package that allows using the feature (if not relevant null)
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: open app settings SFE. Evid: 811.
     * Event description: double click / right click on a wixstores component.
    
     * appName - Type: string. Desc: app name
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page, CurrencyConverter
     *
     * editorMode - Type: string. Desc: mobile / desktop
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isPremiumEligible - Type: bool. Desc: Does the site have a premium package that allows using the feature (if not relevant null)
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid. Desc: store_id
     * @param {openAppSettingsSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.openAppSettingsSfe = function (params) {
        return this.bi.log(__assign({ evid: 811 }, params));
    };
    /**
    * @typedef {Object} imageGalleryOpenedInProductOaParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - msid
    * @property {string} productId - product_id of main product
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    **/
    /**
     * Name: Image gallery opened in product OA SF. Evid: 238.
     * Event description: after memeber clicked on image in product screen gallery opened (OA).
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid. Desc: msid
     *
     * productId - Type: string. Desc: product_id of main product
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     * @param {imageGalleryOpenedInProductOaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.imageGalleryOpenedInProductOa = function (params) {
        return this.bi.log(__assign({ evid: 238 }, params));
    };
    /**
    * @typedef {Object} clickOnCallToActionInMerchantPopUpSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} notificationType - payments/upgrade/shipping
    * @property {GUID} storeId - null
    * @property {string} type - merchant pop-up / buyer pop-up
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: click on call to action in merchant pop-up SF. Evid: 169.
     * Event description: click on call to action (upgrade / set payment) in merchant pop-up.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * notificationType - Type: string. Desc: payments/upgrade/shipping
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: merchant pop-up / buyer pop-up
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {clickOnCallToActionInMerchantPopUpSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnCallToActionInMerchantPopUpSf = function (params) {
        return this.bi.log(__assign({ evid: 169 }, params));
    };
    /**
    * @typedef {Object} viewMiniCartParams
    * @property {string} appName - app_name
    * @property {string} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {boolean} is_member - true is the visitor signed in as a member, false otherwise
    * @property {boolean} isMembersInstalled - true if members app installed on site, false otherwise
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {string} origin - cartIcon / addToCartButton
    * @property {GUID} siteMemberId - member guid
    * @property {GUID} storeId - storeId
    * @property {string} viewMode - editor / site / preview
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: view mini cart. Evid: 50.
     * Event description: view mini cart pop-up.
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: string. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * is_member - Type: bool. Desc: true is the visitor signed in as a member, false otherwise
     *
     * isMembersInstalled - Type: bool. Desc: true if members app installed on site, false otherwise
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: cartIcon / addToCartButton
     *
     * siteMemberId - Type: guid. Desc: member guid
     *
     * storeId - Type: guid. Desc: storeId
     *
     * viewMode - Type: string. Desc: editor / site / preview
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {viewMiniCartParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewMiniCart = function (params) {
        return this.bi.log(__assign({ evid: 50 }, params));
    };
    /**
    * @typedef {Object} changeWidgetButtonActionSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider gallery, product page, product widget...
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - null
    * @property {string} type - chosen button action type (add to cart, view details...)
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change widget button action SFE. Evid: 829.
     * Event description: merchant changes the widget button action in widget settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider gallery, product page, product widget...
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: chosen button action type (add to cart, view details...)
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeWidgetButtonActionSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeWidgetButtonActionSfe = function (params) {
        return this.bi.log(__assign({ evid: 829 }, params));
    };
    /**
    * @typedef {Object} viewEWalletModalSfParams
    * @property {string} appName - app_name
    * @property {GUID} cartId - cart_id
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant, false for member
    * @property {GUID} bi_token - msid
    * @property {number} num_of_shipping - number of shipping choices presented to the visitor
    * @property {string} origin - 'eWallet redirect - cancel' / 'eWallet redirect - continue' / 'cart'
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} shippingMethodType - shipping /store pickup / none
    * @property {GUID} siteMemberId - member id
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: View e-wallet Modal SF. Evid: 224.
     * Event description: When a visitor views e-wallet Modal after clicking on checkout with e-wallet..
    
     * appName - Type: string. Desc: app_name
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant, false for member
     *
     * bi_token - Type: guid. Desc: msid
     *
     * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor
     *
     * origin - Type: string. Desc: 'eWallet redirect - cancel' / 'eWallet redirect - continue' / 'cart'
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * shippingMethodType - Type: string. Desc: shipping /store pickup / none
     *
     * siteMemberId - Type: guid. Desc: member id
     *
     * storeId - Type: guid. Desc: store_id
     * @param {viewEWalletModalSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.viewEWalletModalSf = function (params) {
        return this.bi.log(__assign({ evid: 224 }, params));
    };
    /**
    * @typedef {Object} currencyConverterClickGeneralInfoSfeParams
    * @property {string} appName - currencyconverter-settings
    * @property {GUID} instance_id - instance_id
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: currency converter - click 'General Info' SFE. Evid: 531.
     * Event description: click  'General Info' in currency converter settings (under 'Currencies' panel) in the stores currency tool tip..
    
     * appName - Type: string. Desc: currencyconverter-settings
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {currencyConverterClickGeneralInfoSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.currencyConverterClickGeneralInfoSfe = function (params) {
        return this.bi.log(__assign({ evid: 531 }, params));
    };
    /**
    * @typedef {Object} clickTrackOrderInMyOrderOaStoreFrontParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - msid
    * @property {string} orderId - orderId
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click track order in MyOrder OA StoreFront. Evid: 188.
     * Event description: in MyOrder OA StoreFront buyer (member) can click on "Track order" if merchant already added tracking # (with appropriate link).
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid. Desc: msid
     *
     * orderId - Type: string. Desc: orderId
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickTrackOrderInMyOrderOaStoreFrontParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickTrackOrderInMyOrderOaStoreFront = function (params) {
        return this.bi.log(__assign({ evid: 188 }, params));
    };
    /**
    * @typedef {Object} pictureNavigationInZoomModalSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product has options
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} owner_id - uuid of site owner
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    * @property {string} value - previous / next
    **/
    /**
     * Name: Picture navigation in zoom modal SF. Evid: 493.
     * Event description: When the buyer navigates between the product pictures in the zoom modal in product page.
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product has options
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * owner_id - Type: guid. Desc: uuid of site owner
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     *
     * value - Type: string. Desc: previous / next
     * @param {pictureNavigationInZoomModalSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.pictureNavigationInZoomModalSf = function (params) {
        return this.bi.log(__assign({ evid: 493 }, params));
    };
    /**
    * @typedef {Object} clickLinkInMembersWishlistSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: Click on link in wishlist gallery (empty) SF. Evid: 266.
     * Event description: buyer clicks on the 'add products to wishlist' link in the  wishlist in the Members area.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {clickLinkInMembersWishlistSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickLinkInMembersWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 266 }, params));
    };
    /**
    * @typedef {Object} clickToViewWishlistSfParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - null
    * @property {string} origin - members-menu / login-menu
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: Click to view wishlist SF. Evid: 265.
     * Event description: buyer clicks to view wishlist in the Members area / login menu.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: members-menu / login-menu
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {clickToViewWishlistSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToViewWishlistSf = function (params) {
        return this.bi.log(__assign({ evid: 265 }, params));
    };
    /**
    * @typedef {Object} galleryClickApplyFilterParams
    * @property {string} appName - app
    * @property {string} filterTypes - list of the filter types changed
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Gallery - Click  Apply Filter (Mobile). Evid: 141.
     * Event description: When a visitor clicks "Apply Filter" in mobile only! after he choose the filters.
    
     * appName - Type: string. Desc: app
     *
     * filterTypes - Type: string. Desc: list of the filter types changed
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {galleryClickApplyFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.galleryClickApplyFilter = function (params) {
        return this.bi.log(__assign({ evid: 141 }, params));
    };
    /**
    * @typedef {Object} giftCardCheckoutClickApplyParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {boolean} isMember - true if visitor is member
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} siteMemberId - null
    * @property {GUID} storeId - store_id
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: gift card checkout -> click Apply. Evid: 529.
     * Event description: when visitor clicks "Apply" after entering Gift Card Code in Payment stage of Checkout.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * isMember - Type: bool. Desc: true if visitor is member
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * siteMemberId - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     *
     * visitor_id - Type: guid.
     * @param {giftCardCheckoutClickApplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.giftCardCheckoutClickApply = function (params) {
        return this.bi.log(__assign({ evid: 529 }, params));
    };
    /**
    * @typedef {Object} giftCardCheckoutClickOnCheckboxParams
    * @property {string} appName - null
    * @property {GUID} cartId - cart_id
    * @property {boolean} isMember - true if visitor is member
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} siteMemberId - member
    * @property {GUID} storeId - store_id
    * @property {string} value - checked / unchecked
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: gift card checkout -> click on checkbox. Evid: 527.
     * Event description: when visitor checks / unchecks the Gift Card checkbox in Payment stage of Checkout.
    
     * appName - Type: string.
     *
     * cartId - Type: guid. Desc: cart_id
     *
     * isMember - Type: bool. Desc: true if visitor is member
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * siteMemberId - Type: guid. Desc: member
     *
     * storeId - Type: guid. Desc: store_id
     *
     * value - Type: string. Desc: checked / unchecked
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {giftCardCheckoutClickOnCheckboxParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.giftCardCheckoutClickOnCheckbox = function (params) {
        return this.bi.log(__assign({ evid: 527 }, params));
    };
    /**
    * @typedef {Object} galleryClickClearAllFiltersParams
    * @property {string} appName - app
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Gallery - Click  "clear All" filters. Evid: 142.
     * Event description: When a visitor clicks "Clear All" in mobile only! after he in the filters view.
    
     * appName - Type: string. Desc: app
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {galleryClickClearAllFiltersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.galleryClickClearAllFilters = function (params) {
        return this.bi.log(__assign({ evid: 142 }, params));
    };
    /**
    * @typedef {Object} storeFrontPopupShownClckedOaParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - msid
    * @property {GUID} storeId - store_id
    * @property {string} type - shown / clicked
    **/
    /**
     * Name: StoreFront popup shown/clcked OA. Evid: 189.
     * Event description: Merchant saw/ clicked on StoreFront popup (in MemberView)  . shown only for one time - first entering Store OA.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid. Desc: msid
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: shown / clicked
     * @param {storeFrontPopupShownClckedOaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.storeFrontPopupShownClckedOa = function (params) {
        return this.bi.log(__assign({ evid: 189 }, params));
    };
    /**
    * @typedef {Object} changeProductInWidgetSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galeery, product page
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - null
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: change product in widget SFE. Evid: 826.
     * Event description: merchant changed the product connected to a product widget.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galeery, product page
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid.
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeProductInWidgetSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeProductInWidgetSfe = function (params) {
        return this.bi.log(__assign({ evid: 826 }, params));
    };
    /**
    * @typedef {Object} clickOnCheckoutWithEWalletSfParams
    * @property {string} appName - null
    * @property {string} cartId - null
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected (and displaying in cart)
    * @property {boolean} is_with_offline_payment - does the store has an offline payment connected
    * @property {GUID} bi_token - null
    * @property {number} num_of_paymet_providers - How many payment providers does the store has connected
    * @property {number} num_of_shipping - number of shipping choices presented to the visitor at the first time
    * @property {string} orig_shipping_method - the shipping method that the visitor choose in the cart - free shipping/ Flat rate/ rate by weight/ rate by order price/store pickup (the same strings as in 163 event)
    * @property {string} origin - null
    * @property {string} paymet_providers - array of payment providers connected to the store
    * @property {string} productsList - json containing all product guids for products in the cart
    * @property {string} shippingMethodType - shipping /store pickup / none
    * @property {GUID} storeId - null
    * @property {string} type - e-wallet type
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click on checkout with e-wallet SF. Evid: 113.
     * Event description: buyer clicks on checkout with e-wallwt in cart page.
    
     * appName - Type: string.
     *
     * cartId - Type: string.
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected (and displaying in cart)
     *
     * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
     *
     * bi_token - Type: guid.
     *
     * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
     *
     * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor at the first time
     *
     * orig_shipping_method - Type: string. Desc: the shipping method that the visitor choose in the cart - free shipping/ Flat rate/ rate by weight/ rate by order price/store pickup (the same strings as in 163 event)
     *
     * origin - Type: string.
     *
     * paymet_providers - Type: string. Desc: array of payment providers connected to the store
     *
     * productsList - Type: string. Desc: json containing all product guids for products in the cart
     *
     * shippingMethodType - Type: string. Desc: shipping /store pickup / none
     *
     * storeId - Type: guid.
     *
     * type - Type: string. Desc: e-wallet type
     *
     * visitor_id - Type: guid.
     * @param {clickOnCheckoutWithEWalletSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnCheckoutWithEWalletSf = function (params) {
        return this.bi.log(__assign({ evid: 113 }, params));
    };
    /**
    * @typedef {Object} clickOnCheckoutSfParams
    * @property {string} appName - null
    * @property {GUID} cartId - null
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - null
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for merchant false for member
    * @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected (and displaying in cart)
    * @property {boolean} is_with_offline_payment - does the store has an offline payment connected
    * @property {GUID} bi_token - null
    * @property {number} num_of_paymet_providers - How many payment providers does the store has connected
    * @property {number} num_of_shipping - number of shipping choices presented to the visitor at the first time
    * @property {string} orig_shipping_method - the shipping method that the visitor choose in the cart
    * @property {string} origin - null
    * @property {GUID} owner_id - id of site owner
    * @property {string} paymet_providers - array of payment providers connected to the store
    * @property {string} productsList - json containing all product guids for products in the cart
    * @property {string} shippingMethodType - shipping /store pickup / none
    * @property {GUID} storeId - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Click on checkout SF. Evid: 114.
     * Event description: Click on checkout from Cart page. since june 2019 also sent from OneApp with origin = 'OA StoreFront'.
    
     * appName - Type: string.
     *
     * cartId - Type: guid.
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric.
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for merchant false for member
     *
     * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected (and displaying in cart)
     *
     * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
     *
     * bi_token - Type: guid.
     *
     * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
     *
     * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor at the first time
     *
     * orig_shipping_method - Type: string. Desc: the shipping method that the visitor choose in the cart
     *
     * origin - Type: string.
     *
     * owner_id - Type: guid. Desc: id of site owner
     *
     * paymet_providers - Type: string. Desc: array of payment providers connected to the store
     *
     * productsList - Type: string. Desc: json containing all product guids for products in the cart
     *
     * shippingMethodType - Type: string. Desc: shipping /store pickup / none
     *
     * storeId - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {clickOnCheckoutSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnCheckoutSf = function (params) {
        return this.bi.log(__assign({ evid: 114 }, params));
    };
    /**
    * @typedef {Object} galleryClickSortByParams
    * @property {string} appName - app name
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Gallery -  Click 'Sort By'. Evid: 139.
     * Event description: When the user clicks the sort by button (mobile) / dropdown (desktop).
    
     * appName - Type: string. Desc: app name
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {galleryClickSortByParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.galleryClickSortBy = function (params) {
        return this.bi.log(__assign({ evid: 139 }, params));
    };
    /**
    * @typedef {Object} clickToPreviewWishlistInMembersSfeParams
    * @property {string} appName - null
    * @property {boolean} isMerchant - null
    * @property {GUID} bi_token - null
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: Click to preview Wishlist in Members SFE. Evid: 843.
     * Event description: when a user clicks in notification to preview Wishlist in Members.
    
     * appName - Type: string.
     *
     * isMerchant - Type: bool.
     *
     * bi_token - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     * @param {clickToPreviewWishlistInMembersSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToPreviewWishlistInMembersSfe = function (params) {
        return this.bi.log(__assign({ evid: 843 }, params));
    };
    /**
    * @typedef {Object} changeTextFieldSfeParams
    * @property {string} appName - null
    * @property {string} component_id - grid gallery, slider galery, product page, mini cart....
    * @property {string} field - Icon text, button text, out of stock...
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - null
    * @property {string} origin - editor / onboarding
    * @property {GUID} storeId - null
    * @property {string} text - new text
    * @property {GUID} userGuid - userGuid
    **/
    /**
     * Name: Change text field SFE. Evid: 833.
     * Event description: change the text in store front settings.
    
     * appName - Type: string.
     *
     * component_id - Type: string. Desc: grid gallery, slider galery, product page, mini cart....
     *
     * field - Type: string. Desc: Icon text, button text, out of stock...
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid.
     *
     * origin - Type: string. Desc: editor / onboarding
     *
     * storeId - Type: guid.
     *
     * text - Type: string. Desc: new text
     *
     * userGuid - Type: guid. Desc: userGuid
     * @param {changeTextFieldSfeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeTextFieldSfe = function (params) {
        return this.bi.log(__assign({ evid: 833 }, params));
    };
    /**
    * @typedef {Object} highRpuDismissFeatureAdAssetParams
    * @property {string} appName - app_name
    * @property {string} component_id - CurrencyConverter, AvalaraTax
    * @property {boolean} isMerchant - isMerchant status
    * @property {GUID} bi_token - msid
    * @property {string} origin - editor / onboarding / StoresBO
    * @property {GUID} storeId - store_id
    * @property {string} type - banner
    **/
    /**
     * Name: High RPU -> Dismiss Feature Ad asset. Evid: 237.
     * Event description: when user dismisses Ad asset (e.g. banner) to Upgrade to High RPU to get feature - so it won't be shown any more.
    
     * appName - Type: string. Desc: app_name
     *
     * component_id - Type: string. Desc: CurrencyConverter, AvalaraTax
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * bi_token - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: editor / onboarding / StoresBO
     *
     * storeId - Type: guid. Desc: store_id
     *
     * type - Type: string. Desc: banner
     * @param {highRpuDismissFeatureAdAssetParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.highRpuDismissFeatureAdAsset = function (params) {
        return this.bi.log(__assign({ evid: 237 }, params));
    };
    /**
    * @typedef {Object} clickToViewCartPageSfParams
    * @property {string} appName - app
    * @property {GUID} cartId - cartId
    * @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
    * @property {number} itemsCount - number of items in the cart
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isNavigateCart - hardcoded true -> for Anodot
    * @property {boolean} isOwner - is_owner
    * @property {GUID} bi_token - msid
    * @property {string} origin - add to cart / mini cart / cart widget / checkout...
    * @property {GUID} owner_id - owner_id
    * @property {GUID} storeId - store_id
    * @property {GUID} uuid - uuid
    * @property {string} viewMode - editor / site / preview
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: Click to view cart page SF. Evid: 130.
     * Event description: click to view cart page. since june 2019 also for OneApp Store front.
    
     * appName - Type: string. Desc: app
     *
     * cartId - Type: guid. Desc: cartId
     *
     * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
     *
     * itemsCount - Type: numeric. Desc: number of items in the cart
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isNavigateCart - Type: bool. Desc: hardcoded true -> for Anodot
     *
     * isOwner - Type: bool. Desc: is_owner
     *
     * bi_token - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: add to cart / mini cart / cart widget / checkout...
     *
     * owner_id - Type: guid. Desc: owner_id
     *
     * storeId - Type: guid. Desc: store_id
     *
     * uuid - Type: guid. Desc: uuid
     *
     * viewMode - Type: string. Desc: editor / site / preview
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {clickToViewCartPageSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickToViewCartPageSf = function (params) {
        return this.bi.log(__assign({ evid: 130 }, params));
    };
    /**
    * @typedef {Object} clickAddToCartWithOptionsSfParams
    * @property {string} appName - app_name
    * @property {boolean} hasOptions - does the product has options
    * @property {boolean} isMerchant - isMerchant status
    * @property {boolean} isOwner - true for owner false for member. since june 2019
    * @property {GUID} bi_token - msid
    * @property {string} navigationClick - quick-view / product-page
    * @property {string} options - a json containing the options selected for the product
    * @property {string} origin - add to cart button / gallery / product-widget
    * @property {GUID} owner_id - id of site's owner. since june 2019
    * @property {string} productId - product_guid
    * @property {string} productType - Digital/ Physical
    * @property {GUID} storeId - store_id
    * @property {string} viewMode - editor / site / preview
    **/
    /**
     * Name: click add to cart with options SF. Evid: 248.
     * Event description: buyer clicks on 'Add to Cart' in product-widget / Add to cart button / gallery on a product with options, so the product is not added to the cart and the buyer is navigated to the Product Quick View (in Mobile - Product Page)..
    
     * appName - Type: string. Desc: app_name
     *
     * hasOptions - Type: bool. Desc: does the product has options
     *
     * isMerchant - Type: bool. Desc: isMerchant status
     *
     * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
     *
     * bi_token - Type: guid. Desc: msid
     *
     * navigationClick - Type: string. Desc: quick-view / product-page
     *
     * options - Type: string. Desc: a json containing the options selected for the product
     *
     * origin - Type: string. Desc: add to cart button / gallery / product-widget
     *
     * owner_id - Type: guid. Desc: id of site's owner. since june 2019
     *
     * productId - Type: string. Desc: product_guid
     *
     * productType - Type: string. Desc: Digital/ Physical
     *
     * storeId - Type: guid. Desc: store_id
     *
     * viewMode - Type: string. Desc: editor / site / preview
     * @param {clickAddToCartWithOptionsSfParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickAddToCartWithOptionsSf = function (params) {
        return this.bi.log(__assign({ evid: 248 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 10,
        endpoint: 'ec-sf'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map